(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2e0b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2e0b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6uGhf", function(module, exports) {

$parcel$export(module.exports, "color", () => (parcelRequire("7zw1L")).default);
$parcel$export(module.exports, "scaleDiverging", () => (parcelRequire("wUwgT")).default);
$parcel$export(module.exports, "scaleLinear", () => (parcelRequire("aSvrg")).default);

var $5Dc83 = parcelRequire("5Dc83");


parcelRequire("3v9pd");


var $7zw1L = parcelRequire("7zw1L");

















var $wUwgT = parcelRequire("wUwgT");
var $aSvrg = parcelRequire("aSvrg");






parcelRequire("8czdG");
parcelRequire("eFMgS");

});
parcelRegister("5Dc83", function(module, exports) {
var $419a00d4b2a81f4e$export$a8ff84c12d48cfa6 = "d3";
var $419a00d4b2a81f4e$export$83d89fbfd8236492 = "6.7.0";
var $419a00d4b2a81f4e$export$6d59db4903f20f7d = "Data-Driven Documents";
var $419a00d4b2a81f4e$export$eebaaf2b24d91f63 = [
    "dom",
    "visualization",
    "svg",
    "animation",
    "canvas"
];
var $419a00d4b2a81f4e$export$4cec2234a9c7ce6d = "https://d3js.org";
var $419a00d4b2a81f4e$export$7ff87ebdb8ccbf20 = "BSD-3-Clause";
var $419a00d4b2a81f4e$export$571b02044ddb2ab3 = {
    "name": "Mike Bostock",
    "url": "https://bost.ocks.org/mike"
};
var $419a00d4b2a81f4e$export$f22da7240b7add18 = "dist/d3.node.js";
var $419a00d4b2a81f4e$export$101358e655b23e68 = "dist/d3.min.js";
var $419a00d4b2a81f4e$export$a2877c4988dda7ec = "dist/d3.min.js";
var $419a00d4b2a81f4e$export$130be424786e852f = "index.js";
var $419a00d4b2a81f4e$export$69a68d0c8baaec49 = {
    "type": "git",
    "url": "https://github.com/d3/d3.git"
};
var $419a00d4b2a81f4e$export$3a444357c5f65f65 = [
    "dist/**/*.js",
    "index.js"
];
var $419a00d4b2a81f4e$export$e0fef70db1fd3806 = {
    "pretest": "rimraf dist && mkdir dist && json2module package.json > dist/package.js && rollup -c",
    "test": "tape 'test/**/*-test.js'",
    "prepublishOnly": "yarn test",
    "postpublish": "git push && git push --tags && cd ../d3.github.com && git pull && cp ../d3/dist/d3.js d3.v${npm_package_version%%.*}.js && cp ../d3/dist/d3.min.js d3.v${npm_package_version%%.*}.min.js && git add d3.v${npm_package_version%%.*}.js d3.v${npm_package_version%%.*}.min.js && git commit -m \"d3 ${npm_package_version}\" && git push && cd - && zip -j dist/d3.zip -- LICENSE README.md API.md CHANGES.md dist/d3.js dist/d3.min.js"
};
var $419a00d4b2a81f4e$export$6dbeb9fdb5a4bbaa = {
    "json2module": "0.0",
    "rimraf": "3",
    "rollup": "2",
    "rollup-plugin-ascii": "0.0",
    "rollup-plugin-node-resolve": "5",
    "rollup-plugin-terser": "7",
    "tape": "4",
    "tape-await": "0.1"
};
var $419a00d4b2a81f4e$export$b74ff737e0e298b5 = {
    "d3-array": "2",
    "d3-axis": "2",
    "d3-brush": "2",
    "d3-chord": "2",
    "d3-color": "2",
    "d3-contour": "2",
    "d3-delaunay": "5",
    "d3-dispatch": "2",
    "d3-drag": "2",
    "d3-dsv": "2",
    "d3-ease": "2",
    "d3-fetch": "2",
    "d3-force": "2",
    "d3-format": "2",
    "d3-geo": "2",
    "d3-hierarchy": "2",
    "d3-interpolate": "2",
    "d3-path": "2",
    "d3-polygon": "2",
    "d3-quadtree": "2",
    "d3-random": "2",
    "d3-scale": "3",
    "d3-scale-chromatic": "2",
    "d3-selection": "2",
    "d3-shape": "2",
    "d3-time": "2",
    "d3-time-format": "3",
    "d3-timer": "2",
    "d3-transition": "2",
    "d3-zoom": "2"
};

});

parcelRegister("3v9pd", function(module, exports) {

var $fwQUo = parcelRequire("fwQUo");

});
parcelRegister("fwQUo", function(module, exports) {

var $7cJ51 = parcelRequire("7cJ51");

var $bN3To = parcelRequire("bN3To");

var $8skJo = parcelRequire("8skJo");

var $6xNHt = parcelRequire("6xNHt");
var $8mHRd = parcelRequire("8mHRd");
parcelRequire("8czdG");
var $96buf = parcelRequire("96buf");

var $kiEPI = parcelRequire("kiEPI");

var $gVpv3 = parcelRequire("gVpv3");

var $dV7fx = parcelRequire("dV7fx");
var $b4e2e2bc2c6f9d22$var$MODE_DRAG = {
    name: "drag"
}, $b4e2e2bc2c6f9d22$var$MODE_SPACE = {
    name: "space"
}, $b4e2e2bc2c6f9d22$var$MODE_HANDLE = {
    name: "handle"
}, $b4e2e2bc2c6f9d22$var$MODE_CENTER = {
    name: "center"
};
const { abs: $b4e2e2bc2c6f9d22$var$abs, max: $b4e2e2bc2c6f9d22$var$max, min: $b4e2e2bc2c6f9d22$var$min } = Math;
function $b4e2e2bc2c6f9d22$var$number1(e) {
    return [
        +e[0],
        +e[1]
    ];
}
function $b4e2e2bc2c6f9d22$var$number2(e) {
    return [
        $b4e2e2bc2c6f9d22$var$number1(e[0]),
        $b4e2e2bc2c6f9d22$var$number1(e[1])
    ];
}
var $b4e2e2bc2c6f9d22$var$X = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map($b4e2e2bc2c6f9d22$var$type),
    input: function(x, e) {
        return x == null ? null : [
            [
                +x[0],
                e[0][1]
            ],
            [
                +x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var $b4e2e2bc2c6f9d22$var$Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map($b4e2e2bc2c6f9d22$var$type),
    input: function(y, e) {
        return y == null ? null : [
            [
                e[0][0],
                +y[0]
            ],
            [
                e[1][0],
                +y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var $b4e2e2bc2c6f9d22$var$XY = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map($b4e2e2bc2c6f9d22$var$type),
    input: function(xy) {
        return xy == null ? null : $b4e2e2bc2c6f9d22$var$number2(xy);
    },
    output: function(xy) {
        return xy;
    }
};
var $b4e2e2bc2c6f9d22$var$cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var $b4e2e2bc2c6f9d22$var$flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var $b4e2e2bc2c6f9d22$var$flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var $b4e2e2bc2c6f9d22$var$signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var $b4e2e2bc2c6f9d22$var$signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function $b4e2e2bc2c6f9d22$var$type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function $b4e2e2bc2c6f9d22$var$defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function $b4e2e2bc2c6f9d22$var$defaultExtent() {
    var svg = this.ownerSVGElement || this;
    if (svg.hasAttribute("viewBox")) {
        svg = svg.viewBox.baseVal;
        return [
            [
                svg.x,
                svg.y
            ],
            [
                svg.x + svg.width,
                svg.y + svg.height
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
function $b4e2e2bc2c6f9d22$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function $b4e2e2bc2c6f9d22$var$local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function $b4e2e2bc2c6f9d22$var$empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function $b4e2e2bc2c6f9d22$export$69760394fc76f689(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function $b4e2e2bc2c6f9d22$export$979ace6c88860aa8() {
    return $b4e2e2bc2c6f9d22$var$brush($b4e2e2bc2c6f9d22$var$X);
}
function $b4e2e2bc2c6f9d22$export$468748b530991c54() {
    return $b4e2e2bc2c6f9d22$var$brush($b4e2e2bc2c6f9d22$var$Y);
}
function $b4e2e2bc2c6f9d22$export$2e2bcd8739ae039() {
    return $b4e2e2bc2c6f9d22$var$brush($b4e2e2bc2c6f9d22$var$XY);
}
function $b4e2e2bc2c6f9d22$var$brush(dim) {
    var extent = $b4e2e2bc2c6f9d22$var$defaultExtent, filter = $b4e2e2bc2c6f9d22$var$defaultFilter, touchable = $b4e2e2bc2c6f9d22$var$defaultTouchable, keys = true, listeners = (0, $7cJ51.default)("start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            $b4e2e2bc2c6f9d22$var$type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", $b4e2e2bc2c6f9d22$var$cursors.overlay).merge(overlay).each(function() {
            var extent = $b4e2e2bc2c6f9d22$var$local(this).extent;
            (0, $8mHRd.default)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            $b4e2e2bc2c6f9d22$var$type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", $b4e2e2bc2c6f9d22$var$cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return $b4e2e2bc2c6f9d22$var$cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    brush.move = function(group, selection) {
        if (group.tween) group.on("start.brush", function(event) {
            emitter(this, arguments).beforestart().start(event);
        }).on("interrupt.brush end.brush", function(event) {
            emitter(this, arguments).end(event);
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, $8skJo.default)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && selection1 === null ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 !== null && selection1 !== null ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, $96buf.default)(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start().brush().end();
        });
    };
    brush.clear = function(group) {
        brush.move(group, null);
    };
    function redraw() {
        var group = (0, $8mHRd.default)(this), selection = $b4e2e2bc2c6f9d22$var$local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args, clean) {
        var emit = that.__brush.emitter;
        return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
    }
    function Emitter(that, args, clean) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
        this.clean = clean;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function(event, mode) {
            if (this.starting) this.starting = false, this.emit("start", event, mode);
            else this.emit("brush", event);
            return this;
        },
        brush: function(event, mode) {
            this.emit("brush", event, mode);
            return this;
        },
        end: function(event, mode) {
            if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
            return this;
        },
        emit: function(type, event, mode) {
            var d = (0, $8mHRd.default)(this.that).datum();
            listeners.call(type, this.that, new (0, $gVpv3.default)(type, {
                sourceEvent: event,
                target: brush,
                selection: dim.output(this.state.selection),
                mode: mode,
                dispatch: listeners
            }), d);
        }
    };
    function started(event) {
        if (touchending && !event.touches) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = event.target.__data__.type, mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? $b4e2e2bc2c6f9d22$var$MODE_DRAG : keys && event.altKey ? $b4e2e2bc2c6f9d22$var$MODE_CENTER : $b4e2e2bc2c6f9d22$var$MODE_HANDLE, signX = dim === $b4e2e2bc2c6f9d22$var$Y ? null : $b4e2e2bc2c6f9d22$var$signsX[type], signY = dim === $b4e2e2bc2c6f9d22$var$X ? null : $b4e2e2bc2c6f9d22$var$signsY[type], state = $b4e2e2bc2c6f9d22$var$local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [
            event
        ], (t)=>{
            const i = t.identifier;
            t = (0, $6xNHt.default)(t, that);
            t.point0 = t.slice();
            t.identifier = i;
            return t;
        });
        if (type === "overlay") {
            if (selection) moving = true;
            const pts = [
                points[0],
                points[1] || points[0]
            ];
            state.selection = selection = [
                [
                    w0 = dim === $b4e2e2bc2c6f9d22$var$Y ? W : $b4e2e2bc2c6f9d22$var$min(pts[0][0], pts[1][0]),
                    n0 = dim === $b4e2e2bc2c6f9d22$var$X ? N : $b4e2e2bc2c6f9d22$var$min(pts[0][1], pts[1][1])
                ],
                [
                    e0 = dim === $b4e2e2bc2c6f9d22$var$Y ? E : $b4e2e2bc2c6f9d22$var$max(pts[0][0], pts[1][0]),
                    s0 = dim === $b4e2e2bc2c6f9d22$var$X ? S : $b4e2e2bc2c6f9d22$var$max(pts[0][1], pts[1][1])
                ]
            ];
            if (points.length > 1) move();
        } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, $8mHRd.default)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", $b4e2e2bc2c6f9d22$var$cursors[type]);
        (0, $96buf.default)(that);
        var emit = emitter(that, arguments, true).beforestart();
        if (event.touches) {
            emit.moved = moved;
            emit.ended = ended;
        } else {
            var view = (0, $8mHRd.default)(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
            (0, $bN3To.default)(event.view);
        }
        redraw.call(that);
        emit.start(event, mode.name);
        function moved(event) {
            for (const p of event.changedTouches || [
                event
            ]){
                for (const d of points)if (d.identifier === p.identifier) d.cur = (0, $6xNHt.default)(p, that);
            }
            if (shifting && !lockX && !lockY && points.length === 1) {
                const point = points[0];
                if ($b4e2e2bc2c6f9d22$var$abs(point.cur[0] - point[0]) > $b4e2e2bc2c6f9d22$var$abs(point.cur[1] - point[1])) lockY = true;
                else lockX = true;
            }
            for (const point of points)if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
            moving = true;
            (0, $dV7fx.default)(event);
            move(event);
        }
        function move(event) {
            const point = points[0], point0 = point.point0;
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case $b4e2e2bc2c6f9d22$var$MODE_SPACE:
                case $b4e2e2bc2c6f9d22$var$MODE_DRAG:
                    if (signX) dx = $b4e2e2bc2c6f9d22$var$max(W - w0, $b4e2e2bc2c6f9d22$var$min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = $b4e2e2bc2c6f9d22$var$max(N - n0, $b4e2e2bc2c6f9d22$var$min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case $b4e2e2bc2c6f9d22$var$MODE_HANDLE:
                    if (points[1]) {
                        if (signX) w1 = $b4e2e2bc2c6f9d22$var$max(W, $b4e2e2bc2c6f9d22$var$min(E, points[0][0])), e1 = $b4e2e2bc2c6f9d22$var$max(W, $b4e2e2bc2c6f9d22$var$min(E, points[1][0])), signX = 1;
                        if (signY) n1 = $b4e2e2bc2c6f9d22$var$max(N, $b4e2e2bc2c6f9d22$var$min(S, points[0][1])), s1 = $b4e2e2bc2c6f9d22$var$max(N, $b4e2e2bc2c6f9d22$var$min(S, points[1][1])), signY = 1;
                    } else {
                        if (signX < 0) dx = $b4e2e2bc2c6f9d22$var$max(W - w0, $b4e2e2bc2c6f9d22$var$min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                        else if (signX > 0) dx = $b4e2e2bc2c6f9d22$var$max(W - e0, $b4e2e2bc2c6f9d22$var$min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                        if (signY < 0) dy = $b4e2e2bc2c6f9d22$var$max(N - n0, $b4e2e2bc2c6f9d22$var$min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                        else if (signY > 0) dy = $b4e2e2bc2c6f9d22$var$max(N - s0, $b4e2e2bc2c6f9d22$var$min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    }
                    break;
                case $b4e2e2bc2c6f9d22$var$MODE_CENTER:
                    if (signX) w1 = $b4e2e2bc2c6f9d22$var$max(W, $b4e2e2bc2c6f9d22$var$min(E, w0 - dx * signX)), e1 = $b4e2e2bc2c6f9d22$var$max(W, $b4e2e2bc2c6f9d22$var$min(E, e0 + dx * signX));
                    if (signY) n1 = $b4e2e2bc2c6f9d22$var$max(N, $b4e2e2bc2c6f9d22$var$min(S, n0 - dy * signY)), s1 = $b4e2e2bc2c6f9d22$var$max(N, $b4e2e2bc2c6f9d22$var$min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in $b4e2e2bc2c6f9d22$var$flipX) overlay.attr("cursor", $b4e2e2bc2c6f9d22$var$cursors[type = $b4e2e2bc2c6f9d22$var$flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in $b4e2e2bc2c6f9d22$var$flipY) overlay.attr("cursor", $b4e2e2bc2c6f9d22$var$cursors[type = $b4e2e2bc2c6f9d22$var$flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush(event, mode.name);
            }
        }
        function ended(event) {
            (0, $dV7fx.nopropagation)(event);
            if (event.touches) {
                if (event.touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
            } else {
                (0, $bN3To.yesdrag)(event.view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", $b4e2e2bc2c6f9d22$var$cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if ($b4e2e2bc2c6f9d22$var$empty(selection)) state.selection = null, redraw.call(that);
            emit.end(event, mode.name);
        }
        function keydowned(event) {
            switch(event.keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === $b4e2e2bc2c6f9d22$var$MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = $b4e2e2bc2c6f9d22$var$MODE_CENTER;
                        move();
                    }
                    break;
                case 32:
                    if (mode === $b4e2e2bc2c6f9d22$var$MODE_HANDLE || mode === $b4e2e2bc2c6f9d22$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = $b4e2e2bc2c6f9d22$var$MODE_SPACE;
                        overlay.attr("cursor", $b4e2e2bc2c6f9d22$var$cursors.selection);
                        move();
                    }
                    break;
                default:
                    return;
            }
            (0, $dV7fx.default)(event);
        }
        function keyupped(event) {
            switch(event.keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move();
                    }
                    break;
                case 18:
                    if (mode === $b4e2e2bc2c6f9d22$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = $b4e2e2bc2c6f9d22$var$MODE_HANDLE;
                        move();
                    }
                    break;
                case 32:
                    if (mode === $b4e2e2bc2c6f9d22$var$MODE_SPACE) {
                        if (event.altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = $b4e2e2bc2c6f9d22$var$MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = $b4e2e2bc2c6f9d22$var$MODE_HANDLE;
                        }
                        overlay.attr("cursor", $b4e2e2bc2c6f9d22$var$cursors[type]);
                        move();
                    }
                    break;
                default:
                    return;
            }
            (0, $dV7fx.default)(event);
        }
    }
    function touchmoved(event) {
        emitter(this, arguments).moved(event);
    }
    function touchended(event) {
        emitter(this, arguments).ended(event);
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = $b4e2e2bc2c6f9d22$var$number2(extent.apply(this, arguments));
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $kiEPI.default)($b4e2e2bc2c6f9d22$var$number2(_)), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $kiEPI.default)(!!_), brush) : filter;
    };
    brush.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $kiEPI.default)(!!_), brush) : touchable;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.keyModifiers = function(_) {
        return arguments.length ? (keys = !!_, brush) : keys;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}

});
parcelRegister("7cJ51", function(module, exports) {

$parcel$export(module.exports, "default", () => $53ec9f59ff2a30f7$export$2e2bcd8739ae039);
var $53ec9f59ff2a30f7$var$noop = {
    value: ()=>{}
};
function $53ec9f59ff2a30f7$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $53ec9f59ff2a30f7$var$Dispatch(_);
}
function $53ec9f59ff2a30f7$var$Dispatch(_) {
    this._ = _;
}
function $53ec9f59ff2a30f7$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$53ec9f59ff2a30f7$var$Dispatch.prototype = $53ec9f59ff2a30f7$var$dispatch.prototype = {
    constructor: $53ec9f59ff2a30f7$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $53ec9f59ff2a30f7$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $53ec9f59ff2a30f7$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $53ec9f59ff2a30f7$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $53ec9f59ff2a30f7$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $53ec9f59ff2a30f7$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $53ec9f59ff2a30f7$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $53ec9f59ff2a30f7$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $53ec9f59ff2a30f7$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $53ec9f59ff2a30f7$export$2e2bcd8739ae039 = $53ec9f59ff2a30f7$var$dispatch;

});

parcelRegister("bN3To", function(module, exports) {

$parcel$export(module.exports, "default", () => $89574a449119d685$export$2e2bcd8739ae039);
$parcel$export(module.exports, "yesdrag", () => $89574a449119d685$export$833237748009e1e1);

var $8mHRd = parcelRequire("8mHRd");

var $kGaLr = parcelRequire("kGaLr");
function $89574a449119d685$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $8mHRd.default)(view).on("dragstart.drag", (0, $kGaLr.default), true);
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $kGaLr.default), true);
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $89574a449119d685$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $8mHRd.default)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $kGaLr.default), true);
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}

});
parcelRegister("8mHRd", function(module, exports) {

$parcel$export(module.exports, "default", () => $617265ee89f19b9c$export$2e2bcd8739ae039);

var $huCkF = parcelRequire("huCkF");
function $617265ee89f19b9c$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $huCkF.Selection)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $huCkF.Selection)([
        [
            selector
        ]
    ], (0, $huCkF.root));
}

});
parcelRegister("huCkF", function(module, exports) {

$parcel$export(module.exports, "root", () => $cbc2f9074fd32ba1$export$e8e78c978b129247);
$parcel$export(module.exports, "Selection", () => $cbc2f9074fd32ba1$export$52baac22726c72bf);
$parcel$export(module.exports, "default", () => $cbc2f9074fd32ba1$export$2e2bcd8739ae039);

var $6NfqU = parcelRequire("6NfqU");

var $3Y8o7 = parcelRequire("3Y8o7");

var $kAD22 = parcelRequire("kAD22");

var $eCxxI = parcelRequire("eCxxI");

var $4Pi2i = parcelRequire("4Pi2i");

var $h5HKd = parcelRequire("h5HKd");

var $kHYOR = parcelRequire("kHYOR");

var $2XFOa = parcelRequire("2XFOa");

var $15CaR = parcelRequire("15CaR");

var $4OoC5 = parcelRequire("4OoC5");

var $gXnFg = parcelRequire("gXnFg");

var $gbffG = parcelRequire("gbffG");

var $92hlm = parcelRequire("92hlm");

var $jwSPQ = parcelRequire("jwSPQ");

var $j8s0U = parcelRequire("j8s0U");

var $apkDe = parcelRequire("apkDe");

var $3sEiE = parcelRequire("3sEiE");

var $4LYTM = parcelRequire("4LYTM");

var $3eieK = parcelRequire("3eieK");

var $i3en0 = parcelRequire("i3en0");

var $4WWCx = parcelRequire("4WWCx");

var $gOFo4 = parcelRequire("gOFo4");

var $7SJLD = parcelRequire("7SJLD");

var $4F70Z = parcelRequire("4F70Z");

var $9tTd9 = parcelRequire("9tTd9");

var $03FZI = parcelRequire("03FZI");

var $2M2aA = parcelRequire("2M2aA");

var $4SRr6 = parcelRequire("4SRr6");

var $jbUsu = parcelRequire("jbUsu");

var $1iHDq = parcelRequire("1iHDq");

var $94MCY = parcelRequire("94MCY");

var $erlQE = parcelRequire("erlQE");

var $5fP5z = parcelRequire("5fP5z");

var $7opxH = parcelRequire("7opxH");
var $cbc2f9074fd32ba1$export$e8e78c978b129247 = [
    null
];
function $cbc2f9074fd32ba1$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $cbc2f9074fd32ba1$var$selection() {
    return new $cbc2f9074fd32ba1$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $cbc2f9074fd32ba1$export$e8e78c978b129247);
}
function $cbc2f9074fd32ba1$var$selection_selection() {
    return this;
}
$cbc2f9074fd32ba1$export$52baac22726c72bf.prototype = $cbc2f9074fd32ba1$var$selection.prototype = {
    constructor: $cbc2f9074fd32ba1$export$52baac22726c72bf,
    select: (0, $6NfqU.default),
    selectAll: (0, $3Y8o7.default),
    selectChild: (0, $kAD22.default),
    selectChildren: (0, $eCxxI.default),
    filter: (0, $4Pi2i.default),
    data: (0, $h5HKd.default),
    enter: (0, $kHYOR.default),
    exit: (0, $2XFOa.default),
    join: (0, $15CaR.default),
    merge: (0, $4OoC5.default),
    selection: $cbc2f9074fd32ba1$var$selection_selection,
    order: (0, $gXnFg.default),
    sort: (0, $gbffG.default),
    call: (0, $92hlm.default),
    nodes: (0, $jwSPQ.default),
    node: (0, $j8s0U.default),
    size: (0, $apkDe.default),
    empty: (0, $3sEiE.default),
    each: (0, $4LYTM.default),
    attr: (0, $3eieK.default),
    style: (0, $i3en0.default),
    property: (0, $4WWCx.default),
    classed: (0, $gOFo4.default),
    text: (0, $7SJLD.default),
    html: (0, $4F70Z.default),
    raise: (0, $9tTd9.default),
    lower: (0, $03FZI.default),
    append: (0, $2M2aA.default),
    insert: (0, $4SRr6.default),
    remove: (0, $jbUsu.default),
    clone: (0, $1iHDq.default),
    datum: (0, $94MCY.default),
    on: (0, $erlQE.default),
    dispatch: (0, $5fP5z.default),
    [Symbol.iterator]: (0, $7opxH.default)
};
var $cbc2f9074fd32ba1$export$2e2bcd8739ae039 = $cbc2f9074fd32ba1$var$selection;

});
parcelRegister("6NfqU", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f234a5c8349576c$export$2e2bcd8739ae039);

var $huCkF = parcelRequire("huCkF");

var $fTXhD = parcelRequire("fTXhD");
function $4f234a5c8349576c$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $fTXhD.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $huCkF.Selection)(subgroups, this._parents);
}

});
parcelRegister("fTXhD", function(module, exports) {

$parcel$export(module.exports, "default", () => $b939fa8b637116ea$export$2e2bcd8739ae039);
function $b939fa8b637116ea$var$none() {}
function $b939fa8b637116ea$export$2e2bcd8739ae039(selector) {
    return selector == null ? $b939fa8b637116ea$var$none : function() {
        return this.querySelector(selector);
    };
}

});


parcelRegister("3Y8o7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e3d7b663146cfb8$export$2e2bcd8739ae039);

var $huCkF = parcelRequire("huCkF");

var $1duY9 = parcelRequire("1duY9");

var $jj2Ac = parcelRequire("jj2Ac");
function $2e3d7b663146cfb8$var$arrayAll(select) {
    return function() {
        var group = select.apply(this, arguments);
        return group == null ? [] : (0, $1duY9.default)(group);
    };
}
function $2e3d7b663146cfb8$export$2e2bcd8739ae039(select) {
    if (typeof select === "function") select = $2e3d7b663146cfb8$var$arrayAll(select);
    else select = (0, $jj2Ac.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $huCkF.Selection)(subgroups, parents);
}

});
parcelRegister("1duY9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e2f07281d839937$export$2e2bcd8739ae039);
function $0e2f07281d839937$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("jj2Ac", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0e1cb901e603ac5$export$2e2bcd8739ae039);
function $e0e1cb901e603ac5$var$empty() {
    return [];
}
function $e0e1cb901e603ac5$export$2e2bcd8739ae039(selector) {
    return selector == null ? $e0e1cb901e603ac5$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}

});


parcelRegister("kAD22", function(module, exports) {

$parcel$export(module.exports, "default", () => $efd5725935674ffd$export$2e2bcd8739ae039);

var $aaEMv = parcelRequire("aaEMv");
var $efd5725935674ffd$var$find = Array.prototype.find;
function $efd5725935674ffd$var$childFind(match) {
    return function() {
        return $efd5725935674ffd$var$find.call(this.children, match);
    };
}
function $efd5725935674ffd$var$childFirst() {
    return this.firstElementChild;
}
function $efd5725935674ffd$export$2e2bcd8739ae039(match) {
    return this.select(match == null ? $efd5725935674ffd$var$childFirst : $efd5725935674ffd$var$childFind(typeof match === "function" ? match : (0, $aaEMv.childMatcher)(match)));
}

});
parcelRegister("aaEMv", function(module, exports) {

$parcel$export(module.exports, "default", () => $767a78df28c36f94$export$2e2bcd8739ae039);
$parcel$export(module.exports, "childMatcher", () => $767a78df28c36f94$export$90c2759c036528);
function $767a78df28c36f94$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}
function $767a78df28c36f94$export$90c2759c036528(selector) {
    return function(node) {
        return node.matches(selector);
    };
}

});


parcelRegister("eCxxI", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa4ea233e25cfd7b$export$2e2bcd8739ae039);

var $aaEMv = parcelRequire("aaEMv");
var $aa4ea233e25cfd7b$var$filter = Array.prototype.filter;
function $aa4ea233e25cfd7b$var$children() {
    return this.children;
}
function $aa4ea233e25cfd7b$var$childrenFilter(match) {
    return function() {
        return $aa4ea233e25cfd7b$var$filter.call(this.children, match);
    };
}
function $aa4ea233e25cfd7b$export$2e2bcd8739ae039(match) {
    return this.selectAll(match == null ? $aa4ea233e25cfd7b$var$children : $aa4ea233e25cfd7b$var$childrenFilter(typeof match === "function" ? match : (0, $aaEMv.childMatcher)(match)));
}

});

parcelRegister("4Pi2i", function(module, exports) {

$parcel$export(module.exports, "default", () => $3839ea6eaf2564fb$export$2e2bcd8739ae039);

var $huCkF = parcelRequire("huCkF");

var $aaEMv = parcelRequire("aaEMv");
function $3839ea6eaf2564fb$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $aaEMv.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $huCkF.Selection)(subgroups, this._parents);
}

});

parcelRegister("h5HKd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c714d60c5f9e1d2b$export$2e2bcd8739ae039);

var $huCkF = parcelRequire("huCkF");

var $kHYOR = parcelRequire("kHYOR");

var $1duY9 = parcelRequire("1duY9");

var $bRUqH = parcelRequire("bRUqH");
function $c714d60c5f9e1d2b$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $kHYOR.EnterNode)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $c714d60c5f9e1d2b$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, $kHYOR.EnterNode)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function $c714d60c5f9e1d2b$var$datum(node) {
    return node.__data__;
}
function $c714d60c5f9e1d2b$export$2e2bcd8739ae039(value, key) {
    if (!arguments.length) return Array.from(this, $c714d60c5f9e1d2b$var$datum);
    var bind = key ? $c714d60c5f9e1d2b$var$bindKey : $c714d60c5f9e1d2b$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $bRUqH.default)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = (0, $1duY9.default)(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $huCkF.Selection)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}

});
parcelRegister("kHYOR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f13700404476db39$export$2e2bcd8739ae039);
$parcel$export(module.exports, "EnterNode", () => $f13700404476db39$export$67b01759a14cf6a4);

var $8EaPc = parcelRequire("8EaPc");

var $huCkF = parcelRequire("huCkF");
function $f13700404476db39$export$2e2bcd8739ae039() {
    return new (0, $huCkF.Selection)(this._enter || this._groups.map((0, $8EaPc.default)), this._parents);
}
function $f13700404476db39$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$f13700404476db39$export$67b01759a14cf6a4.prototype = {
    constructor: $f13700404476db39$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};

});
parcelRegister("8EaPc", function(module, exports) {

$parcel$export(module.exports, "default", () => $64ba74b71c73d1e0$export$2e2bcd8739ae039);
function $64ba74b71c73d1e0$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}

});


parcelRegister("bRUqH", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a406ab2db09d134$export$2e2bcd8739ae039);
function $8a406ab2db09d134$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});


parcelRegister("2XFOa", function(module, exports) {

$parcel$export(module.exports, "default", () => $228185ad1cc96e13$export$2e2bcd8739ae039);

var $8EaPc = parcelRequire("8EaPc");

var $huCkF = parcelRequire("huCkF");
function $228185ad1cc96e13$export$2e2bcd8739ae039() {
    return new (0, $huCkF.Selection)(this._exit || this._groups.map((0, $8EaPc.default)), this._parents);
}

});

parcelRegister("15CaR", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cb3deaead1198d9$export$2e2bcd8739ae039);
function $0cb3deaead1198d9$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
    if (onupdate != null) update = onupdate(update);
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}

});

parcelRegister("4OoC5", function(module, exports) {

$parcel$export(module.exports, "default", () => $380eeca35c54fa2f$export$2e2bcd8739ae039);

var $huCkF = parcelRequire("huCkF");
function $380eeca35c54fa2f$export$2e2bcd8739ae039(selection) {
    if (!(selection instanceof (0, $huCkF.Selection))) throw new Error("invalid merge");
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $huCkF.Selection)(merges, this._parents);
}

});

parcelRegister("gXnFg", function(module, exports) {

$parcel$export(module.exports, "default", () => $c58483526176ce71$export$2e2bcd8739ae039);
function $c58483526176ce71$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}

});

parcelRegister("gbffG", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc79812204b4572f$export$2e2bcd8739ae039);

var $huCkF = parcelRequire("huCkF");
function $bc79812204b4572f$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $bc79812204b4572f$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $huCkF.Selection)(sortgroups, this._parents).order();
}
function $bc79812204b4572f$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("92hlm", function(module, exports) {

$parcel$export(module.exports, "default", () => $6941c1024554ae7f$export$2e2bcd8739ae039);
function $6941c1024554ae7f$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}

});

parcelRegister("jwSPQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e37b8a9d231832ad$export$2e2bcd8739ae039);
function $e37b8a9d231832ad$export$2e2bcd8739ae039() {
    return Array.from(this);
}

});

parcelRegister("j8s0U", function(module, exports) {

$parcel$export(module.exports, "default", () => $dee47e9c37232794$export$2e2bcd8739ae039);
function $dee47e9c37232794$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}

});

parcelRegister("apkDe", function(module, exports) {

$parcel$export(module.exports, "default", () => $793c3e3be87954b3$export$2e2bcd8739ae039);
function $793c3e3be87954b3$export$2e2bcd8739ae039() {
    let size = 0;
    for (const node of this)++size; // eslint-disable-line no-unused-vars
    return size;
}

});

parcelRegister("3sEiE", function(module, exports) {

$parcel$export(module.exports, "default", () => $28533f59a8b60696$export$2e2bcd8739ae039);
function $28533f59a8b60696$export$2e2bcd8739ae039() {
    return !this.node();
}

});

parcelRegister("4LYTM", function(module, exports) {

$parcel$export(module.exports, "default", () => $379aca6520fc2ad9$export$2e2bcd8739ae039);
function $379aca6520fc2ad9$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}

});

parcelRegister("3eieK", function(module, exports) {

$parcel$export(module.exports, "default", () => $25a0d35835f0b709$export$2e2bcd8739ae039);

var $6hmKI = parcelRequire("6hmKI");
function $25a0d35835f0b709$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $25a0d35835f0b709$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $25a0d35835f0b709$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $25a0d35835f0b709$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $25a0d35835f0b709$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $25a0d35835f0b709$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $25a0d35835f0b709$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $6hmKI.default)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $25a0d35835f0b709$var$attrRemoveNS : $25a0d35835f0b709$var$attrRemove : typeof value === "function" ? fullname.local ? $25a0d35835f0b709$var$attrFunctionNS : $25a0d35835f0b709$var$attrFunction : fullname.local ? $25a0d35835f0b709$var$attrConstantNS : $25a0d35835f0b709$var$attrConstant)(fullname, value));
}

});
parcelRegister("6hmKI", function(module, exports) {

$parcel$export(module.exports, "default", () => $012e082c833723b3$export$2e2bcd8739ae039);

var $jjAYx = parcelRequire("jjAYx");
function $012e082c833723b3$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $jjAYx.default).hasOwnProperty(prefix) ? {
        space: (0, $jjAYx.default)[prefix],
        local: name
    } : name; // eslint-disable-line no-prototype-builtins
}

});
parcelRegister("jjAYx", function(module, exports) {

$parcel$export(module.exports, "xhtml", () => $e0fc7936b51b9af5$export$201a3f7520ccc326);
$parcel$export(module.exports, "default", () => $e0fc7936b51b9af5$export$2e2bcd8739ae039);
var $e0fc7936b51b9af5$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $e0fc7936b51b9af5$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $e0fc7936b51b9af5$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};

});



parcelRegister("i3en0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d243a764aee7cc25$export$2e2bcd8739ae039);
$parcel$export(module.exports, "styleValue", () => $d243a764aee7cc25$export$5e3cec964f0b5efd);

var $kDvmX = parcelRequire("kDvmX");
function $d243a764aee7cc25$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $d243a764aee7cc25$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $d243a764aee7cc25$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $d243a764aee7cc25$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $d243a764aee7cc25$var$styleRemove : typeof value === "function" ? $d243a764aee7cc25$var$styleFunction : $d243a764aee7cc25$var$styleConstant)(name, value, priority == null ? "" : priority)) : $d243a764aee7cc25$export$5e3cec964f0b5efd(this.node(), name);
}
function $d243a764aee7cc25$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $kDvmX.default)(node).getComputedStyle(node, null).getPropertyValue(name);
}

});
parcelRegister("kDvmX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f05fc874f484bee7$export$2e2bcd8739ae039);
function $f05fc874f484bee7$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}

});


parcelRegister("4WWCx", function(module, exports) {

$parcel$export(module.exports, "default", () => $39aa0d0172b12aba$export$2e2bcd8739ae039);
function $39aa0d0172b12aba$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $39aa0d0172b12aba$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $39aa0d0172b12aba$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $39aa0d0172b12aba$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $39aa0d0172b12aba$var$propertyRemove : typeof value === "function" ? $39aa0d0172b12aba$var$propertyFunction : $39aa0d0172b12aba$var$propertyConstant)(name, value)) : this.node()[name];
}

});

parcelRegister("gOFo4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3e16b79e4b3c1b1$export$2e2bcd8739ae039);
function $c3e16b79e4b3c1b1$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $c3e16b79e4b3c1b1$var$classList(node) {
    return node.classList || new $c3e16b79e4b3c1b1$var$ClassList(node);
}
function $c3e16b79e4b3c1b1$var$ClassList(node) {
    this._node = node;
    this._names = $c3e16b79e4b3c1b1$var$classArray(node.getAttribute("class") || "");
}
$c3e16b79e4b3c1b1$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $c3e16b79e4b3c1b1$var$classedAdd(node, names) {
    var list = $c3e16b79e4b3c1b1$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $c3e16b79e4b3c1b1$var$classedRemove(node, names) {
    var list = $c3e16b79e4b3c1b1$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $c3e16b79e4b3c1b1$var$classedTrue(names) {
    return function() {
        $c3e16b79e4b3c1b1$var$classedAdd(this, names);
    };
}
function $c3e16b79e4b3c1b1$var$classedFalse(names) {
    return function() {
        $c3e16b79e4b3c1b1$var$classedRemove(this, names);
    };
}
function $c3e16b79e4b3c1b1$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $c3e16b79e4b3c1b1$var$classedAdd : $c3e16b79e4b3c1b1$var$classedRemove)(this, names);
    };
}
function $c3e16b79e4b3c1b1$export$2e2bcd8739ae039(name, value) {
    var names = $c3e16b79e4b3c1b1$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $c3e16b79e4b3c1b1$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $c3e16b79e4b3c1b1$var$classedFunction : value ? $c3e16b79e4b3c1b1$var$classedTrue : $c3e16b79e4b3c1b1$var$classedFalse)(names, value));
}

});

parcelRegister("7SJLD", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bd113f738be0adf$export$2e2bcd8739ae039);
function $5bd113f738be0adf$var$textRemove() {
    this.textContent = "";
}
function $5bd113f738be0adf$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $5bd113f738be0adf$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $5bd113f738be0adf$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $5bd113f738be0adf$var$textRemove : (typeof value === "function" ? $5bd113f738be0adf$var$textFunction : $5bd113f738be0adf$var$textConstant)(value)) : this.node().textContent;
}

});

parcelRegister("4F70Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $36506ecc1b1c59fd$export$2e2bcd8739ae039);
function $36506ecc1b1c59fd$var$htmlRemove() {
    this.innerHTML = "";
}
function $36506ecc1b1c59fd$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $36506ecc1b1c59fd$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $36506ecc1b1c59fd$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $36506ecc1b1c59fd$var$htmlRemove : (typeof value === "function" ? $36506ecc1b1c59fd$var$htmlFunction : $36506ecc1b1c59fd$var$htmlConstant)(value)) : this.node().innerHTML;
}

});

parcelRegister("9tTd9", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e71a64943bb84fe$export$2e2bcd8739ae039);
function $6e71a64943bb84fe$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $6e71a64943bb84fe$export$2e2bcd8739ae039() {
    return this.each($6e71a64943bb84fe$var$raise);
}

});

parcelRegister("03FZI", function(module, exports) {

$parcel$export(module.exports, "default", () => $00b0db284e4403f2$export$2e2bcd8739ae039);
function $00b0db284e4403f2$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $00b0db284e4403f2$export$2e2bcd8739ae039() {
    return this.each($00b0db284e4403f2$var$lower);
}

});

parcelRegister("2M2aA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2051bf5bebcff7e5$export$2e2bcd8739ae039);

var $lF6vr = parcelRequire("lF6vr");
function $2051bf5bebcff7e5$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $lF6vr.default)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}

});
parcelRegister("lF6vr", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc52794a0428514e$export$2e2bcd8739ae039);

var $6hmKI = parcelRequire("6hmKI");

var $jjAYx = parcelRequire("jjAYx");
function $fc52794a0428514e$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $jjAYx.xhtml) && document.documentElement.namespaceURI === (0, $jjAYx.xhtml) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $fc52794a0428514e$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $fc52794a0428514e$export$2e2bcd8739ae039(name) {
    var fullname = (0, $6hmKI.default)(name);
    return (fullname.local ? $fc52794a0428514e$var$creatorFixed : $fc52794a0428514e$var$creatorInherit)(fullname);
}

});


parcelRegister("4SRr6", function(module, exports) {

$parcel$export(module.exports, "default", () => $38e5a7dd1f6de5e4$export$2e2bcd8739ae039);

var $lF6vr = parcelRequire("lF6vr");

var $fTXhD = parcelRequire("fTXhD");
function $38e5a7dd1f6de5e4$var$constantNull() {
    return null;
}
function $38e5a7dd1f6de5e4$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $lF6vr.default)(name), select = before == null ? $38e5a7dd1f6de5e4$var$constantNull : typeof before === "function" ? before : (0, $fTXhD.default)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}

});

parcelRegister("jbUsu", function(module, exports) {

$parcel$export(module.exports, "default", () => $df8ad6e702ae825a$export$2e2bcd8739ae039);
function $df8ad6e702ae825a$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $df8ad6e702ae825a$export$2e2bcd8739ae039() {
    return this.each($df8ad6e702ae825a$var$remove);
}

});

parcelRegister("1iHDq", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f2951e34bbb132b$export$2e2bcd8739ae039);
function $0f2951e34bbb132b$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $0f2951e34bbb132b$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $0f2951e34bbb132b$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $0f2951e34bbb132b$var$selection_cloneDeep : $0f2951e34bbb132b$var$selection_cloneShallow);
}

});

parcelRegister("94MCY", function(module, exports) {

$parcel$export(module.exports, "default", () => $69ba35384ab7b4ab$export$2e2bcd8739ae039);
function $69ba35384ab7b4ab$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}

});

parcelRegister("erlQE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a83488e78265bcb8$export$2e2bcd8739ae039);
function $a83488e78265bcb8$var$contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function $a83488e78265bcb8$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $a83488e78265bcb8$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $a83488e78265bcb8$var$onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = $a83488e78265bcb8$var$contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $a83488e78265bcb8$export$2e2bcd8739ae039(typename, value, options) {
    var typenames = $a83488e78265bcb8$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $a83488e78265bcb8$var$onAdd : $a83488e78265bcb8$var$onRemove;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
    return this;
}

});

parcelRegister("5fP5z", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d35fba8300eda05$export$2e2bcd8739ae039);

var $kDvmX = parcelRequire("kDvmX");
function $3d35fba8300eda05$var$dispatchEvent(node, type, params) {
    var window = (0, $kDvmX.default)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $3d35fba8300eda05$var$dispatchConstant(type, params) {
    return function() {
        return $3d35fba8300eda05$var$dispatchEvent(this, type, params);
    };
}
function $3d35fba8300eda05$var$dispatchFunction(type, params) {
    return function() {
        return $3d35fba8300eda05$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $3d35fba8300eda05$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $3d35fba8300eda05$var$dispatchFunction : $3d35fba8300eda05$var$dispatchConstant)(type, params));
}

});

parcelRegister("7opxH", function(module, exports) {

$parcel$export(module.exports, "default", () => $561e967e90ff8d94$export$2e2bcd8739ae039);
function* $561e967e90ff8d94$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
    }
}

});



parcelRegister("kGaLr", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0e01475a53a4f0f$export$2e2bcd8739ae039);
function $f0e01475a53a4f0f$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $f0e01475a53a4f0f$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}

});


parcelRegister("8skJo", function(module, exports) {

$parcel$export(module.exports, "default", () => $62810504b810be74$export$2e2bcd8739ae039);

var $7zw1L = parcelRequire("7zw1L");

var $7T5jl = parcelRequire("7T5jl");

var $6kDMI = parcelRequire("6kDMI");

var $dsSuN = parcelRequire("dsSuN");

var $htN5h = parcelRequire("htN5h");

var $js7bn = parcelRequire("js7bn");

var $3A4bH = parcelRequire("3A4bH");

var $f0hIq = parcelRequire("f0hIq");

var $3vwHA = parcelRequire("3vwHA");
function $62810504b810be74$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $f0hIq.default)(b) : (t === "number" ? (0, $htN5h.default) : t === "string" ? (c = (0, $7zw1L.default)(b)) ? (b = c, $7T5jl.default) : (0, $3A4bH.default) : b instanceof (0, $7zw1L.default) ? (0, $7T5jl.default) : b instanceof Date ? (0, $dsSuN.default) : (0, $3vwHA.isNumberArray)(b) ? (0, $3vwHA.default) : Array.isArray(b) ? (0, $6kDMI.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $js7bn.default) : (0, $htN5h.default))(a, b);
}

});
parcelRegister("7zw1L", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $bFdKO = parcelRequire("bFdKO");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $bFdKO.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $bFdKO.default)(Rgb, rgb, (0, $bFdKO.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $bFdKO.default)(Hsl, hsl, (0, $bFdKO.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("bFdKO", function(module, exports) {

$parcel$export(module.exports, "default", () => $87de3155f9d735d3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $87de3155f9d735d3$export$8b58be045bf06082);
function $87de3155f9d735d3$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $87de3155f9d735d3$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("7T5jl", function(module, exports) {

$parcel$export(module.exports, "default", () => $5be1ca1ac84d1a6e$export$2e2bcd8739ae039);

var $7zw1L = parcelRequire("7zw1L");

var $b6gbg = parcelRequire("b6gbg");

var $9lYTG = parcelRequire("9lYTG");

var $ahvgE = parcelRequire("ahvgE");
var $5be1ca1ac84d1a6e$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $ahvgE.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $7zw1L.rgb)(start)).r, (end = (0, $7zw1L.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $ahvgE.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $5be1ca1ac84d1a6e$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $7zw1L.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $5be1ca1ac84d1a6e$export$2c0e28f2e2852d3f = $5be1ca1ac84d1a6e$var$rgbSpline((0, $b6gbg.default));
var $5be1ca1ac84d1a6e$export$53d5214f625ccd4c = $5be1ca1ac84d1a6e$var$rgbSpline((0, $9lYTG.default));

});
parcelRegister("b6gbg", function(module, exports) {

$parcel$export(module.exports, "basis", () => $814cce61c6a43719$export$4e41033bfeec1a4c);
$parcel$export(module.exports, "default", () => $814cce61c6a43719$export$2e2bcd8739ae039);
function $814cce61c6a43719$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $814cce61c6a43719$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $814cce61c6a43719$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("9lYTG", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cf5501fbd41fd25$export$2e2bcd8739ae039);

var $b6gbg = parcelRequire("b6gbg");
function $6cf5501fbd41fd25$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $b6gbg.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("ahvgE", function(module, exports) {

$parcel$export(module.exports, "gamma", () => $77c3befc81f3cf1f$export$a7ebe8cc6aaf8d37);
$parcel$export(module.exports, "default", () => $77c3befc81f3cf1f$export$2e2bcd8739ae039);

var $f0hIq = parcelRequire("f0hIq");
function $77c3befc81f3cf1f$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $77c3befc81f3cf1f$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $77c3befc81f3cf1f$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $77c3befc81f3cf1f$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $f0hIq.default)(isNaN(a) ? b : a);
}
function $77c3befc81f3cf1f$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $77c3befc81f3cf1f$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $77c3befc81f3cf1f$var$exponential(a, b, y) : (0, $f0hIq.default)(isNaN(a) ? b : a);
    };
}
function $77c3befc81f3cf1f$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $77c3befc81f3cf1f$var$linear(a, d) : (0, $f0hIq.default)(isNaN(a) ? b : a);
}

});
parcelRegister("f0hIq", function(module, exports) {

$parcel$export(module.exports, "default", () => $aec49909c3ef4399$export$2e2bcd8739ae039);
var $aec49909c3ef4399$export$2e2bcd8739ae039 = (x)=>()=>x;

});



parcelRegister("6kDMI", function(module, exports) {

$parcel$export(module.exports, "genericArray", () => $49c378bf74e25e4c$export$15d09067c6a5ee49);

var $8skJo = parcelRequire("8skJo");

var $3vwHA = parcelRequire("3vwHA");
function $49c378bf74e25e4c$export$2e2bcd8739ae039(a, b) {
    return ((0, $3vwHA.isNumberArray)(b) ? (0, $3vwHA.default) : $49c378bf74e25e4c$export$15d09067c6a5ee49)(a, b);
}
function $49c378bf74e25e4c$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $8skJo.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("3vwHA", function(module, exports) {

$parcel$export(module.exports, "default", () => $28dda2443946d247$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isNumberArray", () => $28dda2443946d247$export$5cd576d1827d40c8);
function $28dda2443946d247$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $28dda2443946d247$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("dsSuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cd8299f9981db0b$export$2e2bcd8739ae039);
function $9cd8299f9981db0b$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("htN5h", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb9b382b237fe129$export$2e2bcd8739ae039);
function $cb9b382b237fe129$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("js7bn", function(module, exports) {

$parcel$export(module.exports, "default", () => $e296341fec01fd27$export$2e2bcd8739ae039);

var $8skJo = parcelRequire("8skJo");
function $e296341fec01fd27$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $8skJo.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("3A4bH", function(module, exports) {

$parcel$export(module.exports, "default", () => $29b7fb7bdb66e407$export$2e2bcd8739ae039);

var $htN5h = parcelRequire("htN5h");
var $29b7fb7bdb66e407$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $29b7fb7bdb66e407$var$reB = new RegExp($29b7fb7bdb66e407$var$reA.source, "g");
function $29b7fb7bdb66e407$var$zero(b) {
    return function() {
        return b;
    };
}
function $29b7fb7bdb66e407$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $29b7fb7bdb66e407$export$2e2bcd8739ae039(a, b) {
    var bi = $29b7fb7bdb66e407$var$reA.lastIndex = $29b7fb7bdb66e407$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $29b7fb7bdb66e407$var$reA.exec(a)) && (bm = $29b7fb7bdb66e407$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $htN5h.default)(am, bm)
            });
        }
        bi = $29b7fb7bdb66e407$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $29b7fb7bdb66e407$var$one(q[0].x) : $29b7fb7bdb66e407$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("6xNHt", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c3c60970bdea43e$export$2e2bcd8739ae039);

var $4x7IF = parcelRequire("4x7IF");
function $4c3c60970bdea43e$export$2e2bcd8739ae039(event, node) {
    event = (0, $4x7IF.default)(event);
    if (node === undefined) node = event.currentTarget;
    if (node) {
        var svg = node.ownerSVGElement || node;
        if (svg.createSVGPoint) {
            var point = svg.createSVGPoint();
            point.x = event.clientX, point.y = event.clientY;
            point = point.matrixTransform(node.getScreenCTM().inverse());
            return [
                point.x,
                point.y
            ];
        }
        if (node.getBoundingClientRect) {
            var rect = node.getBoundingClientRect();
            return [
                event.clientX - rect.left - node.clientLeft,
                event.clientY - rect.top - node.clientTop
            ];
        }
    }
    return [
        event.pageX,
        event.pageY
    ];
}

});
parcelRegister("4x7IF", function(module, exports) {

$parcel$export(module.exports, "default", () => $34d03b635d6a2f1a$export$2e2bcd8739ae039);
function $34d03b635d6a2f1a$export$2e2bcd8739ae039(event) {
    let sourceEvent;
    while(sourceEvent = event.sourceEvent)event = sourceEvent;
    return event;
}

});


parcelRegister("8czdG", function(module, exports) {

$parcel$export(module.exports, "interrupt", () => (parcelRequire("96buf")).default);
parcelRequire("gALVo");

var $leops = parcelRequire("leops");

var $4dVnM = parcelRequire("4dVnM");

var $96buf = parcelRequire("96buf");

});
parcelRegister("gALVo", function(module, exports) {

var $huCkF = parcelRequire("huCkF");

var $fmUkD = parcelRequire("fmUkD");

var $6ubzV = parcelRequire("6ubzV");
(0, $huCkF.default).prototype.interrupt = (0, $fmUkD.default);
(0, $huCkF.default).prototype.transition = (0, $6ubzV.default);

});
parcelRegister("fmUkD", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3049b709ccae3c4$export$2e2bcd8739ae039);

var $96buf = parcelRequire("96buf");
function $b3049b709ccae3c4$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $96buf.default)(this, name);
    });
}

});
parcelRegister("96buf", function(module, exports) {

$parcel$export(module.exports, "default", () => $69fd95a8fd5213ef$export$2e2bcd8739ae039);

var $lp6Kl = parcelRequire("lp6Kl");
function $69fd95a8fd5213ef$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $lp6Kl.STARTING) && schedule.state < (0, $lp6Kl.ENDING);
        schedule.state = (0, $lp6Kl.ENDED);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}

});
parcelRegister("lp6Kl", function(module, exports) {

$parcel$export(module.exports, "SCHEDULED", () => $f9512a7ebdd9e68c$export$584530fe98d14a84);
$parcel$export(module.exports, "STARTING", () => $f9512a7ebdd9e68c$export$a5d151aee16efd42);
$parcel$export(module.exports, "ENDING", () => $f9512a7ebdd9e68c$export$a2e792214ded83b2);
$parcel$export(module.exports, "ENDED", () => $f9512a7ebdd9e68c$export$9d38167254403955);
$parcel$export(module.exports, "default", () => $f9512a7ebdd9e68c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "init", () => $f9512a7ebdd9e68c$export$2cd8252107eb640b);
$parcel$export(module.exports, "get", () => $f9512a7ebdd9e68c$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $f9512a7ebdd9e68c$export$adaa4cf7ef1b65be);

var $7cJ51 = parcelRequire("7cJ51");

var $aDSqO = parcelRequire("aDSqO");
var $0a0BW = parcelRequire("0a0BW");
var $f9512a7ebdd9e68c$var$emptyOn = (0, $7cJ51.default)("start", "end", "cancel", "interrupt");
var $f9512a7ebdd9e68c$var$emptyTween = [];
var $f9512a7ebdd9e68c$export$ff39ebd4bb12b718 = 0;
var $f9512a7ebdd9e68c$export$584530fe98d14a84 = 1;
var $f9512a7ebdd9e68c$export$a5d151aee16efd42 = 2;
var $f9512a7ebdd9e68c$export$fb935ab5849a0db9 = 3;
var $f9512a7ebdd9e68c$export$1573e22b087389af = 4;
var $f9512a7ebdd9e68c$export$a2e792214ded83b2 = 5;
var $f9512a7ebdd9e68c$export$9d38167254403955 = 6;
function $f9512a7ebdd9e68c$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $f9512a7ebdd9e68c$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $f9512a7ebdd9e68c$var$emptyOn,
        tween: $f9512a7ebdd9e68c$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $f9512a7ebdd9e68c$export$ff39ebd4bb12b718
    });
}
function $f9512a7ebdd9e68c$export$2cd8252107eb640b(node, id) {
    var schedule = $f9512a7ebdd9e68c$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $f9512a7ebdd9e68c$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $f9512a7ebdd9e68c$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $f9512a7ebdd9e68c$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $f9512a7ebdd9e68c$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $f9512a7ebdd9e68c$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $f9512a7ebdd9e68c$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $0a0BW.timer)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $f9512a7ebdd9e68c$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $f9512a7ebdd9e68c$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $f9512a7ebdd9e68c$export$fb935ab5849a0db9) return (0, $aDSqO.default)(start);
            // Interrupt the active transition, if any.
            if (o.state === $f9512a7ebdd9e68c$export$1573e22b087389af) {
                o.state = $f9512a7ebdd9e68c$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $f9512a7ebdd9e68c$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $aDSqO.default)(function() {
            if (self.state === $f9512a7ebdd9e68c$export$fb935ab5849a0db9) {
                self.state = $f9512a7ebdd9e68c$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $f9512a7ebdd9e68c$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $f9512a7ebdd9e68c$export$a5d151aee16efd42) return; // interrupted
        self.state = $f9512a7ebdd9e68c$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $f9512a7ebdd9e68c$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $f9512a7ebdd9e68c$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $f9512a7ebdd9e68c$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}

});
parcelRegister("aDSqO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bf7c4de278f7c00$export$2e2bcd8739ae039);

var $0a0BW = parcelRequire("0a0BW");
function $7bf7c4de278f7c00$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $0a0BW.Timer);
    delay = delay == null ? 0 : +delay;
    t.restart((elapsed)=>{
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}

});
parcelRegister("0a0BW", function(module, exports) {

$parcel$export(module.exports, "now", () => $0007c3c06f3e7c65$export$461939dd4422153);
$parcel$export(module.exports, "Timer", () => $0007c3c06f3e7c65$export$c57e9b2d8b9e4de);
$parcel$export(module.exports, "timer", () => $0007c3c06f3e7c65$export$9dc4ecf953986f04);
var $0007c3c06f3e7c65$var$frame = 0, $0007c3c06f3e7c65$var$timeout = 0, $0007c3c06f3e7c65$var$interval = 0, $0007c3c06f3e7c65$var$pokeDelay = 1000, $0007c3c06f3e7c65$var$taskHead, $0007c3c06f3e7c65$var$taskTail, $0007c3c06f3e7c65$var$clockLast = 0, $0007c3c06f3e7c65$var$clockNow = 0, $0007c3c06f3e7c65$var$clockSkew = 0, $0007c3c06f3e7c65$var$clock = typeof performance === "object" && performance.now ? performance : Date, $0007c3c06f3e7c65$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $0007c3c06f3e7c65$export$461939dd4422153() {
    return $0007c3c06f3e7c65$var$clockNow || ($0007c3c06f3e7c65$var$setFrame($0007c3c06f3e7c65$var$clearNow), $0007c3c06f3e7c65$var$clockNow = $0007c3c06f3e7c65$var$clock.now() + $0007c3c06f3e7c65$var$clockSkew);
}
function $0007c3c06f3e7c65$var$clearNow() {
    $0007c3c06f3e7c65$var$clockNow = 0;
}
function $0007c3c06f3e7c65$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$0007c3c06f3e7c65$export$c57e9b2d8b9e4de.prototype = $0007c3c06f3e7c65$export$9dc4ecf953986f04.prototype = {
    constructor: $0007c3c06f3e7c65$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $0007c3c06f3e7c65$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $0007c3c06f3e7c65$var$taskTail !== this) {
            if ($0007c3c06f3e7c65$var$taskTail) $0007c3c06f3e7c65$var$taskTail._next = this;
            else $0007c3c06f3e7c65$var$taskHead = this;
            $0007c3c06f3e7c65$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $0007c3c06f3e7c65$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $0007c3c06f3e7c65$var$sleep();
        }
    }
};
function $0007c3c06f3e7c65$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $0007c3c06f3e7c65$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $0007c3c06f3e7c65$export$d60154c1d7f3990e() {
    $0007c3c06f3e7c65$export$461939dd4422153(); // Get the current time, if not already set.
    ++$0007c3c06f3e7c65$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $0007c3c06f3e7c65$var$taskHead, e;
    while(t){
        if ((e = $0007c3c06f3e7c65$var$clockNow - t._time) >= 0) t._call.call(null, e);
        t = t._next;
    }
    --$0007c3c06f3e7c65$var$frame;
}
function $0007c3c06f3e7c65$var$wake() {
    $0007c3c06f3e7c65$var$clockNow = ($0007c3c06f3e7c65$var$clockLast = $0007c3c06f3e7c65$var$clock.now()) + $0007c3c06f3e7c65$var$clockSkew;
    $0007c3c06f3e7c65$var$frame = $0007c3c06f3e7c65$var$timeout = 0;
    try {
        $0007c3c06f3e7c65$export$d60154c1d7f3990e();
    } finally{
        $0007c3c06f3e7c65$var$frame = 0;
        $0007c3c06f3e7c65$var$nap();
        $0007c3c06f3e7c65$var$clockNow = 0;
    }
}
function $0007c3c06f3e7c65$var$poke() {
    var now = $0007c3c06f3e7c65$var$clock.now(), delay = now - $0007c3c06f3e7c65$var$clockLast;
    if (delay > $0007c3c06f3e7c65$var$pokeDelay) $0007c3c06f3e7c65$var$clockSkew -= delay, $0007c3c06f3e7c65$var$clockLast = now;
}
function $0007c3c06f3e7c65$var$nap() {
    var t0, t1 = $0007c3c06f3e7c65$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $0007c3c06f3e7c65$var$taskHead = t2;
    }
    $0007c3c06f3e7c65$var$taskTail = t0;
    $0007c3c06f3e7c65$var$sleep(time);
}
function $0007c3c06f3e7c65$var$sleep(time) {
    if ($0007c3c06f3e7c65$var$frame) return; // Soonest alarm already set, or will be.
    if ($0007c3c06f3e7c65$var$timeout) $0007c3c06f3e7c65$var$timeout = clearTimeout($0007c3c06f3e7c65$var$timeout);
    var delay = time - $0007c3c06f3e7c65$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $0007c3c06f3e7c65$var$timeout = setTimeout($0007c3c06f3e7c65$var$wake, time - $0007c3c06f3e7c65$var$clock.now() - $0007c3c06f3e7c65$var$clockSkew);
        if ($0007c3c06f3e7c65$var$interval) $0007c3c06f3e7c65$var$interval = clearInterval($0007c3c06f3e7c65$var$interval);
    } else {
        if (!$0007c3c06f3e7c65$var$interval) $0007c3c06f3e7c65$var$clockLast = $0007c3c06f3e7c65$var$clock.now(), $0007c3c06f3e7c65$var$interval = setInterval($0007c3c06f3e7c65$var$poke, $0007c3c06f3e7c65$var$pokeDelay);
        $0007c3c06f3e7c65$var$frame = 1, $0007c3c06f3e7c65$var$setFrame($0007c3c06f3e7c65$var$wake);
    }
}

});





parcelRegister("6ubzV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b8e86a3a39a5d2a$export$2e2bcd8739ae039);

var $leops = parcelRequire("leops");

var $lp6Kl = parcelRequire("lp6Kl");

var $brLW1 = parcelRequire("brLW1");

var $0a0BW = parcelRequire("0a0BW");
var $4b8e86a3a39a5d2a$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $brLW1.cubicInOut)
};
function $4b8e86a3a39a5d2a$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}
function $4b8e86a3a39a5d2a$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $leops.Transition)) id = name._id, name = name._name;
    else id = (0, $leops.newId)(), (timing = $4b8e86a3a39a5d2a$var$defaultTiming).time = (0, $0a0BW.now)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $lp6Kl.default)(node, name, id, i, group, timing || $4b8e86a3a39a5d2a$var$inherit(node, id));
    }
    return new (0, $leops.Transition)(groups, this._parents, name, id);
}

});
parcelRegister("leops", function(module, exports) {

$parcel$export(module.exports, "Transition", () => $f74dd700e6e6d3f4$export$be58926105124dd4);
$parcel$export(module.exports, "newId", () => $f74dd700e6e6d3f4$export$9ffd10a3fbdc175b);

var $huCkF = parcelRequire("huCkF");

var $9rgcg = parcelRequire("9rgcg");

var $2dt77 = parcelRequire("2dt77");

var $8xmuw = parcelRequire("8xmuw");

var $4ufDs = parcelRequire("4ufDs");

var $g4lNs = parcelRequire("g4lNs");

var $c4Nme = parcelRequire("c4Nme");

var $69TaT = parcelRequire("69TaT");

var $gjur0 = parcelRequire("gjur0");

var $jcvOK = parcelRequire("jcvOK");

var $ggTER = parcelRequire("ggTER");

var $fq2F3 = parcelRequire("fq2F3");

var $45gkY = parcelRequire("45gkY");

var $8Hpkq = parcelRequire("8Hpkq");

var $iQYBW = parcelRequire("iQYBW");

var $9Y295 = parcelRequire("9Y295");

var $5PNsE = parcelRequire("5PNsE");

var $9Ea32 = parcelRequire("9Ea32");

var $cpVXF = parcelRequire("cpVXF");

var $f7PDQ = parcelRequire("f7PDQ");

var $edwJZ = parcelRequire("edwJZ");
var $f74dd700e6e6d3f4$var$id = 0;
function $f74dd700e6e6d3f4$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $f74dd700e6e6d3f4$export$2e2bcd8739ae039(name) {
    return (0, $huCkF.default)().transition(name);
}
function $f74dd700e6e6d3f4$export$9ffd10a3fbdc175b() {
    return ++$f74dd700e6e6d3f4$var$id;
}
var $f74dd700e6e6d3f4$var$selection_prototype = (0, $huCkF.default).prototype;
$f74dd700e6e6d3f4$export$be58926105124dd4.prototype = $f74dd700e6e6d3f4$export$2e2bcd8739ae039.prototype = {
    constructor: $f74dd700e6e6d3f4$export$be58926105124dd4,
    select: (0, $fq2F3.default),
    selectAll: (0, $45gkY.default),
    filter: (0, $69TaT.default),
    merge: (0, $gjur0.default),
    selection: (0, $8Hpkq.default),
    transition: (0, $cpVXF.default),
    call: $f74dd700e6e6d3f4$var$selection_prototype.call,
    nodes: $f74dd700e6e6d3f4$var$selection_prototype.nodes,
    node: $f74dd700e6e6d3f4$var$selection_prototype.node,
    size: $f74dd700e6e6d3f4$var$selection_prototype.size,
    empty: $f74dd700e6e6d3f4$var$selection_prototype.empty,
    each: $f74dd700e6e6d3f4$var$selection_prototype.each,
    on: (0, $jcvOK.default),
    attr: (0, $9rgcg.default),
    attrTween: (0, $2dt77.default),
    style: (0, $iQYBW.default),
    styleTween: (0, $9Y295.default),
    text: (0, $5PNsE.default),
    textTween: (0, $9Ea32.default),
    remove: (0, $ggTER.default),
    tween: (0, $f7PDQ.default),
    delay: (0, $8xmuw.default),
    duration: (0, $4ufDs.default),
    ease: (0, $g4lNs.default),
    easeVarying: (0, $c4Nme.default),
    end: (0, $edwJZ.default),
    [Symbol.iterator]: $f74dd700e6e6d3f4$var$selection_prototype[Symbol.iterator]
};

});
parcelRegister("9rgcg", function(module, exports) {

$parcel$export(module.exports, "default", () => $6df3330ba39617b0$export$2e2bcd8739ae039);

var $3Aif9 = parcelRequire("3Aif9");

var $6hmKI = parcelRequire("6hmKI");

var $f7PDQ = parcelRequire("f7PDQ");

var $aIbJE = parcelRequire("aIbJE");
function $6df3330ba39617b0$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $6df3330ba39617b0$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $6df3330ba39617b0$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $6df3330ba39617b0$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $6df3330ba39617b0$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $6df3330ba39617b0$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $6df3330ba39617b0$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $6hmKI.default)(name), i = fullname === "transform" ? (0, $3Aif9.interpolateTransformSvg) : (0, $aIbJE.default);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $6df3330ba39617b0$var$attrFunctionNS : $6df3330ba39617b0$var$attrFunction)(fullname, i, (0, $f7PDQ.tweenValue)(this, "attr." + name, value)) : value == null ? (fullname.local ? $6df3330ba39617b0$var$attrRemoveNS : $6df3330ba39617b0$var$attrRemove)(fullname) : (fullname.local ? $6df3330ba39617b0$var$attrConstantNS : $6df3330ba39617b0$var$attrConstant)(fullname, i, value));
}

});
parcelRegister("3Aif9", function(module, exports) {

$parcel$export(module.exports, "interpolateTransformCss", () => $29c2e2ab21710ad5$export$56bec7123bb3589a);
$parcel$export(module.exports, "interpolateTransformSvg", () => $29c2e2ab21710ad5$export$da8cba906d64c082);

var $htN5h = parcelRequire("htN5h");

var $4qaDl = parcelRequire("4qaDl");
function $29c2e2ab21710ad5$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $htN5h.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $htN5h.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $htN5h.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $htN5h.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $htN5h.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $htN5h.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $29c2e2ab21710ad5$export$56bec7123bb3589a = $29c2e2ab21710ad5$var$interpolateTransform((0, $4qaDl.parseCss), "px, ", "px)", "deg)");
var $29c2e2ab21710ad5$export$da8cba906d64c082 = $29c2e2ab21710ad5$var$interpolateTransform((0, $4qaDl.parseSvg), ", ", ")", ")");

});
parcelRegister("4qaDl", function(module, exports) {

$parcel$export(module.exports, "parseCss", () => $3381d6bd383a1118$export$59ad369bf4938177);
$parcel$export(module.exports, "parseSvg", () => $3381d6bd383a1118$export$f9ef43f9a1d89a18);

var $92H5S = parcelRequire("92H5S");
var $3381d6bd383a1118$var$svgNode;
function $3381d6bd383a1118$export$59ad369bf4938177(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, $92H5S.identity) : (0, $92H5S.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $3381d6bd383a1118$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $92H5S.identity;
    if (!$3381d6bd383a1118$var$svgNode) $3381d6bd383a1118$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $3381d6bd383a1118$var$svgNode.setAttribute("transform", value);
    if (!(value = $3381d6bd383a1118$var$svgNode.transform.baseVal.consolidate())) return 0, $92H5S.identity;
    value = value.matrix;
    return (0, $92H5S.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("92H5S", function(module, exports) {

$parcel$export(module.exports, "identity", () => $6955ba823262b394$export$f0954fd7d5368655);
$parcel$export(module.exports, "default", () => $6955ba823262b394$export$2e2bcd8739ae039);
var $6955ba823262b394$var$degrees = 180 / Math.PI;
var $6955ba823262b394$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $6955ba823262b394$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $6955ba823262b394$var$degrees,
        skewX: Math.atan(skewX) * $6955ba823262b394$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("f7PDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b02f9169704b8a5a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "tweenValue", () => $b02f9169704b8a5a$export$f78ce6ab10405d82);

var $lp6Kl = parcelRequire("lp6Kl");
function $b02f9169704b8a5a$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $lp6Kl.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $b02f9169704b8a5a$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $lp6Kl.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $b02f9169704b8a5a$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $lp6Kl.get)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $b02f9169704b8a5a$var$tweenRemove : $b02f9169704b8a5a$var$tweenFunction)(id, name, value));
}
function $b02f9169704b8a5a$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $lp6Kl.set)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $lp6Kl.get)(node, id).value[name];
    };
}

});

parcelRegister("aIbJE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cc71dd6abbe2d85$export$2e2bcd8739ae039);

var $7zw1L = parcelRequire("7zw1L");

var $htN5h = parcelRequire("htN5h");
var $7T5jl = parcelRequire("7T5jl");
var $3A4bH = parcelRequire("3A4bH");
function $7cc71dd6abbe2d85$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $htN5h.default) : b instanceof (0, $7zw1L.default) ? (0, $7T5jl.default) : (c = (0, $7zw1L.default)(b)) ? (b = c, $7T5jl.default) : (0, $3A4bH.default))(a, b);
}

});


parcelRegister("2dt77", function(module, exports) {

$parcel$export(module.exports, "default", () => $19d3610d91eac892$export$2e2bcd8739ae039);

var $6hmKI = parcelRequire("6hmKI");
function $19d3610d91eac892$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $19d3610d91eac892$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $19d3610d91eac892$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $19d3610d91eac892$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $19d3610d91eac892$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $19d3610d91eac892$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $19d3610d91eac892$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $6hmKI.default)(name);
    return this.tween(key, (fullname.local ? $19d3610d91eac892$var$attrTweenNS : $19d3610d91eac892$var$attrTween)(fullname, value));
}

});

parcelRegister("8xmuw", function(module, exports) {

$parcel$export(module.exports, "default", () => $6372da1b33409b0c$export$2e2bcd8739ae039);

var $lp6Kl = parcelRequire("lp6Kl");
function $6372da1b33409b0c$var$delayFunction(id, value) {
    return function() {
        (0, $lp6Kl.init)(this, id).delay = +value.apply(this, arguments);
    };
}
function $6372da1b33409b0c$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $lp6Kl.init)(this, id).delay = value;
    };
}
function $6372da1b33409b0c$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $6372da1b33409b0c$var$delayFunction : $6372da1b33409b0c$var$delayConstant)(id, value)) : (0, $lp6Kl.get)(this.node(), id).delay;
}

});

parcelRegister("4ufDs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3446179eea101172$export$2e2bcd8739ae039);

var $lp6Kl = parcelRequire("lp6Kl");
function $3446179eea101172$var$durationFunction(id, value) {
    return function() {
        (0, $lp6Kl.set)(this, id).duration = +value.apply(this, arguments);
    };
}
function $3446179eea101172$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $lp6Kl.set)(this, id).duration = value;
    };
}
function $3446179eea101172$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $3446179eea101172$var$durationFunction : $3446179eea101172$var$durationConstant)(id, value)) : (0, $lp6Kl.get)(this.node(), id).duration;
}

});

parcelRegister("g4lNs", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb2ded6b6415a353$export$2e2bcd8739ae039);

var $lp6Kl = parcelRequire("lp6Kl");
function $bb2ded6b6415a353$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $lp6Kl.set)(this, id).ease = value;
    };
}
function $bb2ded6b6415a353$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($bb2ded6b6415a353$var$easeConstant(id, value)) : (0, $lp6Kl.get)(this.node(), id).ease;
}

});

parcelRegister("c4Nme", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cac2526ee9e1ca9$export$2e2bcd8739ae039);

var $lp6Kl = parcelRequire("lp6Kl");
function $8cac2526ee9e1ca9$var$easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, $lp6Kl.set)(this, id).ease = v;
    };
}
function $8cac2526ee9e1ca9$export$2e2bcd8739ae039(value) {
    if (typeof value !== "function") throw new Error;
    return this.each($8cac2526ee9e1ca9$var$easeVarying(this._id, value));
}

});

parcelRegister("69TaT", function(module, exports) {

$parcel$export(module.exports, "default", () => $47be61e6cfe05bcf$export$2e2bcd8739ae039);

var $aaEMv = parcelRequire("aaEMv");

var $leops = parcelRequire("leops");
function $47be61e6cfe05bcf$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $aaEMv.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $leops.Transition)(subgroups, this._parents, this._name, this._id);
}

});

parcelRegister("gjur0", function(module, exports) {

$parcel$export(module.exports, "default", () => $be06075b70f591f1$export$2e2bcd8739ae039);

var $leops = parcelRequire("leops");
function $be06075b70f591f1$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $leops.Transition)(merges, this._parents, this._name, this._id);
}

});

parcelRegister("jcvOK", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfa7d1a18c74d7ce$export$2e2bcd8739ae039);

var $lp6Kl = parcelRequire("lp6Kl");
function $dfa7d1a18c74d7ce$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $dfa7d1a18c74d7ce$var$onFunction(id, name, listener) {
    var on0, on1, sit = $dfa7d1a18c74d7ce$var$start(name) ? (0, $lp6Kl.init) : (0, $lp6Kl.set);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $dfa7d1a18c74d7ce$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $lp6Kl.get)(this.node(), id).on.on(name) : this.each($dfa7d1a18c74d7ce$var$onFunction(id, name, listener));
}

});

parcelRegister("ggTER", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd8950781d1621f0$export$2e2bcd8739ae039);
function $bd8950781d1621f0$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $bd8950781d1621f0$export$2e2bcd8739ae039() {
    return this.on("end.remove", $bd8950781d1621f0$var$removeFunction(this._id));
}

});

parcelRegister("fq2F3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b39b59274b919b95$export$2e2bcd8739ae039);

var $fTXhD = parcelRequire("fTXhD");

var $leops = parcelRequire("leops");

var $lp6Kl = parcelRequire("lp6Kl");
function $b39b59274b919b95$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $fTXhD.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $lp6Kl.default)(subgroup[i], name, id, i, subgroup, (0, $lp6Kl.get)(node, id));
        }
    }
    return new (0, $leops.Transition)(subgroups, this._parents, name, id);
}

});

parcelRegister("45gkY", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f944d477a4ff0a1$export$2e2bcd8739ae039);

var $jj2Ac = parcelRequire("jj2Ac");

var $leops = parcelRequire("leops");

var $lp6Kl = parcelRequire("lp6Kl");
function $2f944d477a4ff0a1$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $jj2Ac.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $lp6Kl.get)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $lp6Kl.default)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $leops.Transition)(subgroups, parents, name, id);
}

});

parcelRegister("8Hpkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6555fc9ab5e01e93$export$2e2bcd8739ae039);

var $huCkF = parcelRequire("huCkF");
var $6555fc9ab5e01e93$var$Selection = (0, $huCkF.default).prototype.constructor;
function $6555fc9ab5e01e93$export$2e2bcd8739ae039() {
    return new $6555fc9ab5e01e93$var$Selection(this._groups, this._parents);
}

});

parcelRegister("iQYBW", function(module, exports) {

$parcel$export(module.exports, "default", () => $db9c1965b96c4625$export$2e2bcd8739ae039);

var $3Aif9 = parcelRequire("3Aif9");

var $i3en0 = parcelRequire("i3en0");

var $lp6Kl = parcelRequire("lp6Kl");

var $f7PDQ = parcelRequire("f7PDQ");

var $aIbJE = parcelRequire("aIbJE");
function $db9c1965b96c4625$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $i3en0.styleValue)(this, name), string1 = (this.style.removeProperty(name), (0, $i3en0.styleValue)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $db9c1965b96c4625$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $db9c1965b96c4625$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $i3en0.styleValue)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $db9c1965b96c4625$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $i3en0.styleValue)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $i3en0.styleValue)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $db9c1965b96c4625$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $lp6Kl.set)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $db9c1965b96c4625$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $db9c1965b96c4625$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $3Aif9.interpolateTransformCss) : (0, $aIbJE.default);
    return value == null ? this.styleTween(name, $db9c1965b96c4625$var$styleNull(name, i)).on("end.style." + name, $db9c1965b96c4625$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $db9c1965b96c4625$var$styleFunction(name, i, (0, $f7PDQ.tweenValue)(this, "style." + name, value))).each($db9c1965b96c4625$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $db9c1965b96c4625$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}

});

parcelRegister("9Y295", function(module, exports) {

$parcel$export(module.exports, "default", () => $741b61b8d63a6914$export$2e2bcd8739ae039);
function $741b61b8d63a6914$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $741b61b8d63a6914$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $741b61b8d63a6914$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $741b61b8d63a6914$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $741b61b8d63a6914$var$styleTween(name, value, priority == null ? "" : priority));
}

});

parcelRegister("5PNsE", function(module, exports) {

$parcel$export(module.exports, "default", () => $43f81522a0032ac6$export$2e2bcd8739ae039);

var $f7PDQ = parcelRequire("f7PDQ");
function $43f81522a0032ac6$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $43f81522a0032ac6$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $43f81522a0032ac6$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $43f81522a0032ac6$var$textFunction((0, $f7PDQ.tweenValue)(this, "text", value)) : $43f81522a0032ac6$var$textConstant(value == null ? "" : value + ""));
}

});

parcelRegister("9Ea32", function(module, exports) {

$parcel$export(module.exports, "default", () => $705fa4d4f686bf7a$export$2e2bcd8739ae039);
function $705fa4d4f686bf7a$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $705fa4d4f686bf7a$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $705fa4d4f686bf7a$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $705fa4d4f686bf7a$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $705fa4d4f686bf7a$var$textTween(value));
}

});

parcelRegister("cpVXF", function(module, exports) {

$parcel$export(module.exports, "default", () => $90a4c7bd9b302d92$export$2e2bcd8739ae039);

var $leops = parcelRequire("leops");

var $lp6Kl = parcelRequire("lp6Kl");
function $90a4c7bd9b302d92$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $leops.newId)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $lp6Kl.get)(node, id0);
            (0, $lp6Kl.default)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $leops.Transition)(groups, this._parents, name, id1);
}

});

parcelRegister("edwJZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a59bad37f396d212$export$2e2bcd8739ae039);

var $lp6Kl = parcelRequire("lp6Kl");
function $a59bad37f396d212$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $lp6Kl.set)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
        // The selection was empty, resolve end immediately
        if (size === 0) resolve();
    });
}

});


parcelRegister("brLW1", function(module, exports) {

$parcel$export(module.exports, "cubicInOut", () => $8557663587796bd4$export$89238d3bc79d3ada);
function $8557663587796bd4$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $8557663587796bd4$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $8557663587796bd4$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

});



parcelRegister("4dVnM", function(module, exports) {

var $leops = parcelRequire("leops");

var $lp6Kl = parcelRequire("lp6Kl");
var $3134e34a2931fb90$var$root = [
    null
];
function $3134e34a2931fb90$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, i;
    if (schedules) {
        name = name == null ? null : name + "";
        for(i in schedules){
            if ((schedule = schedules[i]).state > (0, $lp6Kl.SCHEDULED) && schedule.name === name) return new (0, $leops.Transition)([
                [
                    node
                ]
            ], $3134e34a2931fb90$var$root, name, +i);
        }
    }
    return null;
}

});


parcelRegister("kiEPI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec7529b5bc1eeb68$export$2e2bcd8739ae039);
var $ec7529b5bc1eeb68$export$2e2bcd8739ae039 = (x)=>()=>x;

});

parcelRegister("gVpv3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c525bff5c15ae1c1$export$2e2bcd8739ae039);
function $c525bff5c15ae1c1$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, selection: selection, mode: mode, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        selection: {
            value: selection,
            enumerable: true,
            configurable: true
        },
        mode: {
            value: mode,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}

});

parcelRegister("dV7fx", function(module, exports) {

$parcel$export(module.exports, "nopropagation", () => $a22638d87ba06a09$export$2e2561858db9bf47);
$parcel$export(module.exports, "default", () => $a22638d87ba06a09$export$2e2bcd8739ae039);
function $a22638d87ba06a09$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $a22638d87ba06a09$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}

});



parcelRegister("wUwgT", function(module, exports) {

$parcel$export(module.exports, "default", () => $062ed4def101d7fa$export$2e2bcd8739ae039);

var $6JuYh = parcelRequire("6JuYh");
var $bmlMK = parcelRequire("bmlMK");
var $9M96w = parcelRequire("9M96w");

var $aNOl6 = parcelRequire("aNOl6");

var $iGmDW = parcelRequire("iGmDW");

var $aSvrg = parcelRequire("aSvrg");

var $lh0D1 = parcelRequire("lh0D1");

var $cUX6y = parcelRequire("cUX6y");

var $gGeSO = parcelRequire("gGeSO");

var $3xref = parcelRequire("3xref");
function $062ed4def101d7fa$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = (0, $aNOl6.identity), transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $9M96w.default)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $6JuYh.default));
    scale.rangeRound = range((0, $bmlMK.default));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $062ed4def101d7fa$export$2e2bcd8739ae039() {
    var scale = (0, $aSvrg.linearish)($062ed4def101d7fa$var$transformer()((0, $aNOl6.identity)));
    scale.copy = function() {
        return (0, $cUX6y.copy)(scale, $062ed4def101d7fa$export$2e2bcd8739ae039());
    };
    return (0, $iGmDW.initInterpolator).apply(scale, arguments);
}
function $062ed4def101d7fa$export$5f0266a9159c47fb() {
    var scale = (0, $lh0D1.loggish)($062ed4def101d7fa$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $cUX6y.copy)(scale, $062ed4def101d7fa$export$5f0266a9159c47fb()).base(scale.base());
    };
    return (0, $iGmDW.initInterpolator).apply(scale, arguments);
}
function $062ed4def101d7fa$export$50b3da713cf557c6() {
    var scale = (0, $gGeSO.symlogish)($062ed4def101d7fa$var$transformer());
    scale.copy = function() {
        return (0, $cUX6y.copy)(scale, $062ed4def101d7fa$export$50b3da713cf557c6()).constant(scale.constant());
    };
    return (0, $iGmDW.initInterpolator).apply(scale, arguments);
}
function $062ed4def101d7fa$export$d6cedcc63bf26e7e() {
    var scale = (0, $3xref.powish)($062ed4def101d7fa$var$transformer());
    scale.copy = function() {
        return (0, $cUX6y.copy)(scale, $062ed4def101d7fa$export$d6cedcc63bf26e7e()).exponent(scale.exponent());
    };
    return (0, $iGmDW.initInterpolator).apply(scale, arguments);
}
function $062ed4def101d7fa$export$33ddefb5c4ab9e9c() {
    return $062ed4def101d7fa$export$d6cedcc63bf26e7e.apply(null, arguments).exponent(0.5);
}

});
parcelRegister("6JuYh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e6ef844ac4b3a47$export$2e2bcd8739ae039);

var $e1U5l = parcelRequire("e1U5l");

var $dFDiJ = parcelRequire("dFDiJ");

var $3IkHg = parcelRequire("3IkHg");

var $fw8eO = parcelRequire("fw8eO");

var $fxmGQ = parcelRequire("fxmGQ");

var $9oPd3 = parcelRequire("9oPd3");

var $dNfKS = parcelRequire("dNfKS");

var $lFlsW = parcelRequire("lFlsW");

var $k994c = parcelRequire("k994c");
function $4e6ef844ac4b3a47$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $lFlsW.default)(b) : (t === "number" ? (0, $fxmGQ.default) : t === "string" ? (c = (0, $e1U5l.default)(b)) ? (b = c, $dFDiJ.default) : (0, $dNfKS.default) : b instanceof (0, $e1U5l.default) ? (0, $dFDiJ.default) : b instanceof Date ? (0, $fw8eO.default) : (0, $k994c.isNumberArray)(b) ? (0, $k994c.default) : Array.isArray(b) ? (0, $3IkHg.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $9oPd3.default) : (0, $fxmGQ.default))(a, b);
}

});
parcelRegister("e1U5l", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $ioX81 = parcelRequire("ioX81");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $ioX81.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $ioX81.default)(Rgb, rgb, (0, $ioX81.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $ioX81.default)(Hsl, hsl, (0, $ioX81.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("ioX81", function(module, exports) {

$parcel$export(module.exports, "default", () => $037509a362c79022$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $037509a362c79022$export$8b58be045bf06082);
function $037509a362c79022$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $037509a362c79022$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("dFDiJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f3d9714057a674e$export$2e2bcd8739ae039);

var $e1U5l = parcelRequire("e1U5l");

var $etJnf = parcelRequire("etJnf");

var $e5IXz = parcelRequire("e5IXz");

var $kKoo2 = parcelRequire("kKoo2");
var $9f3d9714057a674e$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $kKoo2.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $e1U5l.rgb)(start)).r, (end = (0, $e1U5l.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $kKoo2.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $9f3d9714057a674e$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $e1U5l.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $9f3d9714057a674e$export$2c0e28f2e2852d3f = $9f3d9714057a674e$var$rgbSpline((0, $etJnf.default));
var $9f3d9714057a674e$export$53d5214f625ccd4c = $9f3d9714057a674e$var$rgbSpline((0, $e5IXz.default));

});
parcelRegister("etJnf", function(module, exports) {

$parcel$export(module.exports, "basis", () => $a8a6f872a67f9f91$export$4e41033bfeec1a4c);
$parcel$export(module.exports, "default", () => $a8a6f872a67f9f91$export$2e2bcd8739ae039);
function $a8a6f872a67f9f91$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $a8a6f872a67f9f91$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $a8a6f872a67f9f91$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("e5IXz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4246869a2b2013d$export$2e2bcd8739ae039);

var $etJnf = parcelRequire("etJnf");
function $a4246869a2b2013d$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $etJnf.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("kKoo2", function(module, exports) {

$parcel$export(module.exports, "gamma", () => $f1ab053cfa8196f9$export$a7ebe8cc6aaf8d37);
$parcel$export(module.exports, "default", () => $f1ab053cfa8196f9$export$2e2bcd8739ae039);

var $lFlsW = parcelRequire("lFlsW");
function $f1ab053cfa8196f9$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $f1ab053cfa8196f9$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $f1ab053cfa8196f9$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $f1ab053cfa8196f9$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $lFlsW.default)(isNaN(a) ? b : a);
}
function $f1ab053cfa8196f9$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $f1ab053cfa8196f9$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $f1ab053cfa8196f9$var$exponential(a, b, y) : (0, $lFlsW.default)(isNaN(a) ? b : a);
    };
}
function $f1ab053cfa8196f9$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $f1ab053cfa8196f9$var$linear(a, d) : (0, $lFlsW.default)(isNaN(a) ? b : a);
}

});
parcelRegister("lFlsW", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc5e13f4bdfeecbb$export$2e2bcd8739ae039);
var $fc5e13f4bdfeecbb$export$2e2bcd8739ae039 = (x)=>()=>x;

});



parcelRegister("3IkHg", function(module, exports) {

$parcel$export(module.exports, "genericArray", () => $2b45891ca744d3db$export$15d09067c6a5ee49);

var $6JuYh = parcelRequire("6JuYh");

var $k994c = parcelRequire("k994c");
function $2b45891ca744d3db$export$2e2bcd8739ae039(a, b) {
    return ((0, $k994c.isNumberArray)(b) ? (0, $k994c.default) : $2b45891ca744d3db$export$15d09067c6a5ee49)(a, b);
}
function $2b45891ca744d3db$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $6JuYh.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("k994c", function(module, exports) {

$parcel$export(module.exports, "default", () => $eaabae5aec58682c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isNumberArray", () => $eaabae5aec58682c$export$5cd576d1827d40c8);
function $eaabae5aec58682c$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $eaabae5aec58682c$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("fw8eO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4c03c06faca7439$export$2e2bcd8739ae039);
function $b4c03c06faca7439$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("fxmGQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4fb89d7e21add48$export$2e2bcd8739ae039);
function $b4fb89d7e21add48$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("9oPd3", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d7e141c27bcdec9$export$2e2bcd8739ae039);

var $6JuYh = parcelRequire("6JuYh");
function $6d7e141c27bcdec9$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $6JuYh.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("dNfKS", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0ac1293c2d5ecbd$export$2e2bcd8739ae039);

var $fxmGQ = parcelRequire("fxmGQ");
var $a0ac1293c2d5ecbd$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $a0ac1293c2d5ecbd$var$reB = new RegExp($a0ac1293c2d5ecbd$var$reA.source, "g");
function $a0ac1293c2d5ecbd$var$zero(b) {
    return function() {
        return b;
    };
}
function $a0ac1293c2d5ecbd$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $a0ac1293c2d5ecbd$export$2e2bcd8739ae039(a, b) {
    var bi = $a0ac1293c2d5ecbd$var$reA.lastIndex = $a0ac1293c2d5ecbd$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $a0ac1293c2d5ecbd$var$reA.exec(a)) && (bm = $a0ac1293c2d5ecbd$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $fxmGQ.default)(am, bm)
            });
        }
        bi = $a0ac1293c2d5ecbd$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $a0ac1293c2d5ecbd$var$one(q[0].x) : $a0ac1293c2d5ecbd$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("bmlMK", function(module, exports) {

$parcel$export(module.exports, "default", () => $8452a5df9255c68e$export$2e2bcd8739ae039);
function $8452a5df9255c68e$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("9M96w", function(module, exports) {

$parcel$export(module.exports, "default", () => $71dfa8a5df6ac0fc$export$2e2bcd8739ae039);

var $6JuYh = parcelRequire("6JuYh");
function $71dfa8a5df6ac0fc$export$2e2bcd8739ae039(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = (0, $6JuYh.default);
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRegister("aNOl6", function(module, exports) {

$parcel$export(module.exports, "identity", () => $7dd587536c83aff7$export$f0954fd7d5368655);
$parcel$export(module.exports, "copy", () => $7dd587536c83aff7$export$784d13d8ee351f07);
$parcel$export(module.exports, "transformer", () => $7dd587536c83aff7$export$6b468dcfb64c653c);
$parcel$export(module.exports, "default", () => $7dd587536c83aff7$export$2e2bcd8739ae039);

var $cB7hd = parcelRequire("cB7hd");

var $6JuYh = parcelRequire("6JuYh");
var $fxmGQ = parcelRequire("fxmGQ");
var $bmlMK = parcelRequire("bmlMK");

var $84Czd = parcelRequire("84Czd");

var $6sY3H = parcelRequire("6sY3H");
var $7dd587536c83aff7$var$unit = [
    0,
    1
];
function $7dd587536c83aff7$export$f0954fd7d5368655(x) {
    return x;
}
function $7dd587536c83aff7$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $84Czd.default)(isNaN(b) ? NaN : 0.5);
}
function $7dd587536c83aff7$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $7dd587536c83aff7$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $7dd587536c83aff7$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $7dd587536c83aff7$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $7dd587536c83aff7$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $7dd587536c83aff7$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $cB7hd.default)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $7dd587536c83aff7$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $7dd587536c83aff7$export$6b468dcfb64c653c() {
    var domain = $7dd587536c83aff7$var$unit, range = $7dd587536c83aff7$var$unit, interpolate = (0, $6JuYh.default), transform, untransform, unknown, clamp = $7dd587536c83aff7$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $7dd587536c83aff7$export$f0954fd7d5368655) clamp = $7dd587536c83aff7$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $7dd587536c83aff7$var$polymap : $7dd587536c83aff7$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $fxmGQ.default))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $6sY3H.default)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $bmlMK.default), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $7dd587536c83aff7$export$f0954fd7d5368655, rescale()) : clamp !== $7dd587536c83aff7$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $7dd587536c83aff7$export$2e2bcd8739ae039() {
    return $7dd587536c83aff7$export$6b468dcfb64c653c()($7dd587536c83aff7$export$f0954fd7d5368655, $7dd587536c83aff7$export$f0954fd7d5368655);
}

});
parcelRegister("cB7hd", function(module, exports) {

$parcel$export(module.exports, "default", () => $92be95bfb77a34dd$export$2e2bcd8739ae039);

var $733O4 = parcelRequire("733O4");

var $1xmrF = parcelRequire("1xmrF");

var $30m79 = parcelRequire("30m79");
const $92be95bfb77a34dd$var$ascendingBisect = (0, $1xmrF.default)((0, $733O4.default));
const $92be95bfb77a34dd$export$4d945ad3ad5751b0 = $92be95bfb77a34dd$var$ascendingBisect.right;
const $92be95bfb77a34dd$export$df7d25c84ebd12a5 = $92be95bfb77a34dd$var$ascendingBisect.left;
const $92be95bfb77a34dd$export$c1cb828b1117c77b = (0, $1xmrF.default)((0, $30m79.default)).center;
var $92be95bfb77a34dd$export$2e2bcd8739ae039 = $92be95bfb77a34dd$export$4d945ad3ad5751b0;

});
parcelRegister("733O4", function(module, exports) {

$parcel$export(module.exports, "default", () => $521bc42303c41d3f$export$2e2bcd8739ae039);
function $521bc42303c41d3f$export$2e2bcd8739ae039(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("1xmrF", function(module, exports) {

$parcel$export(module.exports, "default", () => $11ea48af9b87e2dd$export$2e2bcd8739ae039);

var $733O4 = parcelRequire("733O4");
function $11ea48af9b87e2dd$export$2e2bcd8739ae039(f) {
    let delta = f;
    let compare = f;
    if (f.length === 1) {
        delta = (d, x)=>f(d) - x;
        compare = $11ea48af9b87e2dd$var$ascendingComparator(f);
    }
    function left(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while(lo < hi){
            const mid = lo + hi >>> 1;
            if (compare(a[mid], x) < 0) lo = mid + 1;
            else hi = mid;
        }
        return lo;
    }
    function right(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while(lo < hi){
            const mid = lo + hi >>> 1;
            if (compare(a[mid], x) > 0) hi = mid;
            else lo = mid + 1;
        }
        return lo;
    }
    function center(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $11ea48af9b87e2dd$var$ascendingComparator(f) {
    return (d, x)=>(0, $733O4.default)(f(d), x);
}

});

parcelRegister("30m79", function(module, exports) {

$parcel$export(module.exports, "default", () => $230286a6954ff4a3$export$2e2bcd8739ae039);
function $230286a6954ff4a3$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $230286a6954ff4a3$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("84Czd", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e0c9d0e02557db5$export$2e2bcd8739ae039);
function $5e0c9d0e02557db5$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("6sY3H", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b53f1fd03e1a986$export$2e2bcd8739ae039);
function $4b53f1fd03e1a986$export$2e2bcd8739ae039(x) {
    return +x;
}

});


parcelRegister("iGmDW", function(module, exports) {

$parcel$export(module.exports, "initRange", () => $d99db6b9f4809fde$export$23c7bb9e6558da2a);
$parcel$export(module.exports, "initInterpolator", () => $d99db6b9f4809fde$export$7d6b419e59e83f3d);
function $d99db6b9f4809fde$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $d99db6b9f4809fde$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("aSvrg", function(module, exports) {

$parcel$export(module.exports, "linearish", () => $7eb7559767ab28a3$export$16a5d4b4a61a274d);
$parcel$export(module.exports, "default", () => $7eb7559767ab28a3$export$2e2bcd8739ae039);

var $3um73 = parcelRequire("3um73");

var $aNOl6 = parcelRequire("aNOl6");

var $iGmDW = parcelRequire("iGmDW");

var $edgk5 = parcelRequire("edgk5");
function $7eb7559767ab28a3$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $3um73.default)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $edgk5.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $3um73.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $7eb7559767ab28a3$export$2e2bcd8739ae039() {
    var scale = (0, $aNOl6.default)();
    scale.copy = function() {
        return (0, $aNOl6.copy)(scale, $7eb7559767ab28a3$export$2e2bcd8739ae039());
    };
    (0, $iGmDW.initRange).apply(scale, arguments);
    return $7eb7559767ab28a3$export$16a5d4b4a61a274d(scale);
}

});
parcelRegister("3um73", function(module, exports) {

$parcel$export(module.exports, "default", () => $28a55395a79a6785$export$2e2bcd8739ae039);
$parcel$export(module.exports, "tickIncrement", () => $28a55395a79a6785$export$bc64d00cc98e7e95);
$parcel$export(module.exports, "tickStep", () => $28a55395a79a6785$export$81087d9b915d4ede);
var $28a55395a79a6785$var$e10 = Math.sqrt(50), $28a55395a79a6785$var$e5 = Math.sqrt(10), $28a55395a79a6785$var$e2 = Math.sqrt(2);
function $28a55395a79a6785$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $28a55395a79a6785$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $28a55395a79a6785$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $28a55395a79a6785$var$e10 ? 10 : error >= $28a55395a79a6785$var$e5 ? 5 : error >= $28a55395a79a6785$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $28a55395a79a6785$var$e10 ? 10 : error >= $28a55395a79a6785$var$e5 ? 5 : error >= $28a55395a79a6785$var$e2 ? 2 : 1);
}
function $28a55395a79a6785$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $28a55395a79a6785$var$e10) step1 *= 10;
    else if (error >= $28a55395a79a6785$var$e5) step1 *= 5;
    else if (error >= $28a55395a79a6785$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});

parcelRegister("edgk5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a58ef0ffdff81f44$export$2e2bcd8739ae039);

var $3um73 = parcelRequire("3um73");

var $2Znxj = parcelRequire("2Znxj");
var $eHEu2 = parcelRequire("eHEu2");
var $5FDlc = parcelRequire("5FDlc");
var $81T5G = parcelRequire("81T5G");
var $djxyw = parcelRequire("djxyw");
function $a58ef0ffdff81f44$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $3um73.tickStep)(start, stop, count), precision;
    specifier = (0, $eHEu2.default)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $81T5G.default)(step, value))) specifier.precision = precision;
            return (0, $2Znxj.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $djxyw.default)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $5FDlc.default)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $2Znxj.format)(specifier);
}

});
parcelRegister("2Znxj", function(module, exports) {

$parcel$export(module.exports, "format", () => $22d3891b0a8207dc$export$d9468344d3651243);
$parcel$export(module.exports, "formatPrefix", () => $22d3891b0a8207dc$export$8d85692a469dde6f);

var $6jrXW = parcelRequire("6jrXW");
var $22d3891b0a8207dc$var$locale;
var $22d3891b0a8207dc$export$d9468344d3651243;
var $22d3891b0a8207dc$export$8d85692a469dde6f;
$22d3891b0a8207dc$export$2e2bcd8739ae039({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $22d3891b0a8207dc$export$2e2bcd8739ae039(definition) {
    $22d3891b0a8207dc$var$locale = (0, $6jrXW.default)(definition);
    $22d3891b0a8207dc$export$d9468344d3651243 = $22d3891b0a8207dc$var$locale.format;
    $22d3891b0a8207dc$export$8d85692a469dde6f = $22d3891b0a8207dc$var$locale.formatPrefix;
    return $22d3891b0a8207dc$var$locale;
}

});
parcelRegister("6jrXW", function(module, exports) {

$parcel$export(module.exports, "default", () => $498a35d68f49e7e2$export$2e2bcd8739ae039);

var $KN7ee = parcelRequire("KN7ee");

var $7wwOm = parcelRequire("7wwOm");

var $2fbAQ = parcelRequire("2fbAQ");

var $eHEu2 = parcelRequire("eHEu2");

var $aW3cW = parcelRequire("aW3cW");

var $7XVtR = parcelRequire("7XVtR");

var $4j2D3 = parcelRequire("4j2D3");

var $cFVbY = parcelRequire("cFVbY");
var $498a35d68f49e7e2$var$map = Array.prototype.map, $498a35d68f49e7e2$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $498a35d68f49e7e2$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $cFVbY.default) : (0, $7wwOm.default)($498a35d68f49e7e2$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $cFVbY.default) : (0, $2fbAQ.default)($498a35d68f49e7e2$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $eHEu2.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $7XVtR.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $7XVtR.default)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $aW3cW.default)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $498a35d68f49e7e2$var$prefixes[8 + (0, $4j2D3.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $eHEu2.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $KN7ee.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $498a35d68f49e7e2$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("KN7ee", function(module, exports) {

$parcel$export(module.exports, "default", () => $08ca65535483c84a$export$2e2bcd8739ae039);

var $7IWiR = parcelRequire("7IWiR");
function $08ca65535483c84a$export$2e2bcd8739ae039(x) {
    return x = (0, $7IWiR.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("7IWiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $59f9de4283371c3d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "formatDecimalParts", () => $59f9de4283371c3d$export$8f8e23dd27dc19f5);
function $59f9de4283371c3d$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $59f9de4283371c3d$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("7wwOm", function(module, exports) {

$parcel$export(module.exports, "default", () => $57a4f9340c729126$export$2e2bcd8739ae039);
function $57a4f9340c729126$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("2fbAQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a25f9af2d42035d$export$2e2bcd8739ae039);
function $1a25f9af2d42035d$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("eHEu2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab447c01a5372829$export$2e2bcd8739ae039);
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $ab447c01a5372829$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $ab447c01a5372829$export$2e2bcd8739ae039(specifier) {
    if (!(match = $ab447c01a5372829$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $ab447c01a5372829$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$ab447c01a5372829$export$2e2bcd8739ae039.prototype = $ab447c01a5372829$export$963aac351db36ed4.prototype; // instanceof
function $ab447c01a5372829$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$ab447c01a5372829$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("aW3cW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f61cf24ddaee9e2$export$2e2bcd8739ae039);
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $7f61cf24ddaee9e2$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("7XVtR", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ccaa18de028dacc$export$2e2bcd8739ae039);

var $7IWiR = parcelRequire("7IWiR");

var $4j2D3 = parcelRequire("4j2D3");

var $bb5Zx = parcelRequire("bb5Zx");
var $5ccaa18de028dacc$export$2e2bcd8739ae039 = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, $7IWiR.default),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $bb5Zx.default)(x * 100, p),
    "r": (0, $bb5Zx.default),
    "s": (0, $4j2D3.default),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};

});
parcelRegister("4j2D3", function(module, exports) {

$parcel$export(module.exports, "prefixExponent", () => $322af9d78239adb9$export$6863724d9a42263);
$parcel$export(module.exports, "default", () => $322af9d78239adb9$export$2e2bcd8739ae039);

var $7IWiR = parcelRequire("7IWiR");
var $322af9d78239adb9$export$6863724d9a42263;
function $322af9d78239adb9$export$2e2bcd8739ae039(x, p) {
    var d = (0, $7IWiR.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($322af9d78239adb9$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $7IWiR.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("bb5Zx", function(module, exports) {

$parcel$export(module.exports, "default", () => $82355e931f5c47fe$export$2e2bcd8739ae039);

var $7IWiR = parcelRequire("7IWiR");
function $82355e931f5c47fe$export$2e2bcd8739ae039(x, p) {
    var d = (0, $7IWiR.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("cFVbY", function(module, exports) {

$parcel$export(module.exports, "default", () => $93a5ad840c97a223$export$2e2bcd8739ae039);
function $93a5ad840c97a223$export$2e2bcd8739ae039(x) {
    return x;
}

});



parcelRegister("5FDlc", function(module, exports) {

$parcel$export(module.exports, "default", () => $420f4c647bf8858f$export$2e2bcd8739ae039);

var $KN7ee = parcelRequire("KN7ee");
function $420f4c647bf8858f$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $KN7ee.default)(Math.abs(step)));
}

});

parcelRegister("81T5G", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d89269b2b96d903$export$2e2bcd8739ae039);

var $KN7ee = parcelRequire("KN7ee");
function $5d89269b2b96d903$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $KN7ee.default)(value) / 3))) * 3 - (0, $KN7ee.default)(Math.abs(step)));
}

});

parcelRegister("djxyw", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b17143390a46e38$export$2e2bcd8739ae039);

var $KN7ee = parcelRequire("KN7ee");
function $9b17143390a46e38$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $KN7ee.default)(max) - (0, $KN7ee.default)(step)) + 1;
}

});



parcelRegister("lh0D1", function(module, exports) {

$parcel$export(module.exports, "loggish", () => $f7cbac45ef330d6b$export$860836db074028f0);

var $3um73 = parcelRequire("3um73");

var $2Znxj = parcelRequire("2Znxj");

var $7vI1J = parcelRequire("7vI1J");

var $aNOl6 = parcelRequire("aNOl6");

var $iGmDW = parcelRequire("iGmDW");
function $f7cbac45ef330d6b$var$transformLog(x) {
    return Math.log(x);
}
function $f7cbac45ef330d6b$var$transformExp(x) {
    return Math.exp(x);
}
function $f7cbac45ef330d6b$var$transformLogn(x) {
    return -Math.log(-x);
}
function $f7cbac45ef330d6b$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $f7cbac45ef330d6b$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $f7cbac45ef330d6b$var$powp(base) {
    return base === 10 ? $f7cbac45ef330d6b$var$pow10 : base === Math.E ? Math.exp : function(x) {
        return Math.pow(base, x);
    };
}
function $f7cbac45ef330d6b$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), function(x) {
        return Math.log(x) / base;
    });
}
function $f7cbac45ef330d6b$var$reflect(f) {
    return function(x) {
        return -f(-x);
    };
}
function $f7cbac45ef330d6b$export$860836db074028f0(transform) {
    var scale = transform($f7cbac45ef330d6b$var$transformLog, $f7cbac45ef330d6b$var$transformExp), domain = scale.domain, base = 10, logs, pows;
    function rescale() {
        logs = $f7cbac45ef330d6b$var$logp(base), pows = $f7cbac45ef330d6b$var$powp(base);
        if (domain()[0] < 0) {
            logs = $f7cbac45ef330d6b$var$reflect(logs), pows = $f7cbac45ef330d6b$var$reflect(pows);
            transform($f7cbac45ef330d6b$var$transformLogn, $f7cbac45ef330d6b$var$transformExpn);
        } else transform($f7cbac45ef330d6b$var$transformLog, $f7cbac45ef330d6b$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = function(count) {
        var d = domain(), u = d[0], v = d[d.length - 1], r;
        if (r = v < u) i = u, u = v, v = i;
        var i = logs(u), j = logs(v), p, k, t, n = count == null ? 10 : +count, z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1, p = pows(i); k < base; ++k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1, p = pows(i); k >= 1; --k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $3um73.default)(u, v, n);
        } else z = (0, $3um73.default)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = function(count, specifier) {
        if (specifier == null) specifier = base === 10 ? ".0e" : ",";
        if (typeof specifier !== "function") specifier = (0, $2Znxj.format)(specifier);
        if (count === Infinity) return specifier;
        if (count == null) count = 10;
        var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return function(d) {
            var i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = function() {
        return domain((0, $7vI1J.default)(domain(), {
            floor: function(x) {
                return pows(Math.floor(logs(x)));
            },
            ceil: function(x) {
                return pows(Math.ceil(logs(x)));
            }
        }));
    };
    return scale;
}
function $f7cbac45ef330d6b$export$2e2bcd8739ae039() {
    var scale = $f7cbac45ef330d6b$export$860836db074028f0((0, $aNOl6.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $aNOl6.copy)(scale, $f7cbac45ef330d6b$export$2e2bcd8739ae039()).base(scale.base());
    };
    (0, $iGmDW.initRange).apply(scale, arguments);
    return scale;
}

});
parcelRegister("7vI1J", function(module, exports) {

$parcel$export(module.exports, "default", () => $577d948182c6aae1$export$2e2bcd8739ae039);
function $577d948182c6aae1$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("cUX6y", function(module, exports) {

$parcel$export(module.exports, "copy", () => $96788ff93b613852$export$784d13d8ee351f07);

var $6JuYh = parcelRequire("6JuYh");
var $bmlMK = parcelRequire("bmlMK");

var $aNOl6 = parcelRequire("aNOl6");

var $iGmDW = parcelRequire("iGmDW");

var $aSvrg = parcelRequire("aSvrg");

var $lh0D1 = parcelRequire("lh0D1");

var $gGeSO = parcelRequire("gGeSO");

var $3xref = parcelRequire("3xref");
function $96788ff93b613852$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, $aNOl6.identity), clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $6JuYh.default));
    scale.rangeRound = range((0, $bmlMK.default));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $96788ff93b613852$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $96788ff93b613852$export$2e2bcd8739ae039() {
    var scale = (0, $aSvrg.linearish)($96788ff93b613852$var$transformer()((0, $aNOl6.identity)));
    scale.copy = function() {
        return $96788ff93b613852$export$784d13d8ee351f07(scale, $96788ff93b613852$export$2e2bcd8739ae039());
    };
    return (0, $iGmDW.initInterpolator).apply(scale, arguments);
}
function $96788ff93b613852$export$6843e08bf2ff981f() {
    var scale = (0, $lh0D1.loggish)($96788ff93b613852$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $96788ff93b613852$export$784d13d8ee351f07(scale, $96788ff93b613852$export$6843e08bf2ff981f()).base(scale.base());
    };
    return (0, $iGmDW.initInterpolator).apply(scale, arguments);
}
function $96788ff93b613852$export$9d4af4de62c81941() {
    var scale = (0, $gGeSO.symlogish)($96788ff93b613852$var$transformer());
    scale.copy = function() {
        return $96788ff93b613852$export$784d13d8ee351f07(scale, $96788ff93b613852$export$9d4af4de62c81941()).constant(scale.constant());
    };
    return (0, $iGmDW.initInterpolator).apply(scale, arguments);
}
function $96788ff93b613852$export$de9f78581b4f2405() {
    var scale = (0, $3xref.powish)($96788ff93b613852$var$transformer());
    scale.copy = function() {
        return $96788ff93b613852$export$784d13d8ee351f07(scale, $96788ff93b613852$export$de9f78581b4f2405()).exponent(scale.exponent());
    };
    return (0, $iGmDW.initInterpolator).apply(scale, arguments);
}
function $96788ff93b613852$export$413d935127ed466e() {
    return $96788ff93b613852$export$de9f78581b4f2405.apply(null, arguments).exponent(0.5);
}

});
parcelRegister("gGeSO", function(module, exports) {

$parcel$export(module.exports, "symlogish", () => $c24c1d0768db7e3c$export$4602684e614eba38);

var $aSvrg = parcelRequire("aSvrg");

var $aNOl6 = parcelRequire("aNOl6");

var $iGmDW = parcelRequire("iGmDW");
function $c24c1d0768db7e3c$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $c24c1d0768db7e3c$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $c24c1d0768db7e3c$export$4602684e614eba38(transform) {
    var c = 1, scale = transform($c24c1d0768db7e3c$var$transformSymlog(c), $c24c1d0768db7e3c$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($c24c1d0768db7e3c$var$transformSymlog(c = +_), $c24c1d0768db7e3c$var$transformSymexp(c)) : c;
    };
    return (0, $aSvrg.linearish)(scale);
}
function $c24c1d0768db7e3c$export$2e2bcd8739ae039() {
    var scale = $c24c1d0768db7e3c$export$4602684e614eba38((0, $aNOl6.transformer)());
    scale.copy = function() {
        return (0, $aNOl6.copy)(scale, $c24c1d0768db7e3c$export$2e2bcd8739ae039()).constant(scale.constant());
    };
    return (0, $iGmDW.initRange).apply(scale, arguments);
}

});

parcelRegister("3xref", function(module, exports) {

$parcel$export(module.exports, "powish", () => $29399341a46df5cd$export$34695211ec403a46);

var $aSvrg = parcelRequire("aSvrg");

var $aNOl6 = parcelRequire("aNOl6");

var $iGmDW = parcelRequire("iGmDW");
function $29399341a46df5cd$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $29399341a46df5cd$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $29399341a46df5cd$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $29399341a46df5cd$export$34695211ec403a46(transform) {
    var scale = transform((0, $aNOl6.identity), (0, $aNOl6.identity)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, $aNOl6.identity), (0, $aNOl6.identity)) : exponent === 0.5 ? transform($29399341a46df5cd$var$transformSqrt, $29399341a46df5cd$var$transformSquare) : transform($29399341a46df5cd$var$transformPow(exponent), $29399341a46df5cd$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $aSvrg.linearish)(scale);
}
function $29399341a46df5cd$export$2e2bcd8739ae039() {
    var scale = $29399341a46df5cd$export$34695211ec403a46((0, $aNOl6.transformer)());
    scale.copy = function() {
        return (0, $aNOl6.copy)(scale, $29399341a46df5cd$export$2e2bcd8739ae039()).exponent(scale.exponent());
    };
    (0, $iGmDW.initRange).apply(scale, arguments);
    return scale;
}
function $29399341a46df5cd$export$eba8049fb5020b81() {
    return $29399341a46df5cd$export$2e2bcd8739ae039.apply(null, arguments).exponent(0.5);
}

});



parcelRegister("eFMgS", function(module, exports) {

var $fakZL = parcelRequire("fakZL");

var $7iDKc = parcelRequire("7iDKc");

});
parcelRegister("fakZL", function(module, exports) {

var $7cJ51 = parcelRequire("7cJ51");

var $bN3To = parcelRequire("bN3To");

var $8u0ed = parcelRequire("8u0ed");

var $6xNHt = parcelRequire("6xNHt");
var $8mHRd = parcelRequire("8mHRd");
parcelRequire("8czdG");
var $96buf = parcelRequire("96buf");

var $4Es4f = parcelRequire("4Es4f");

var $eUaWk = parcelRequire("eUaWk");

var $7iDKc = parcelRequire("7iDKc");

var $4U5Zm = parcelRequire("4U5Zm");
// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function $b0a81369feaadb1e$var$defaultFilter(event) {
    return (!event.ctrlKey || event.type === 'wheel') && !event.button;
}
function $b0a81369feaadb1e$var$defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function $b0a81369feaadb1e$var$defaultTransform() {
    return this.__zoom || (0, $7iDKc.identity);
}
function $b0a81369feaadb1e$var$defaultWheelDelta(event) {
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}
function $b0a81369feaadb1e$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $b0a81369feaadb1e$var$defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function $b0a81369feaadb1e$export$2e2bcd8739ae039() {
    var filter = $b0a81369feaadb1e$var$defaultFilter, extent = $b0a81369feaadb1e$var$defaultExtent, constrain = $b0a81369feaadb1e$var$defaultConstrain, wheelDelta = $b0a81369feaadb1e$var$defaultWheelDelta, touchable = $b0a81369feaadb1e$var$defaultTouchable, scaleExtent = [
        0,
        Infinity
    ], translateExtent = [
        [
            -Infinity,
            -Infinity
        ],
        [
            Infinity,
            Infinity
        ]
    ], duration = 250, interpolate = (0, $8u0ed.default), listeners = (0, $7cJ51.default)("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
    function zoom(selection) {
        selection.property("__zoom", $b0a81369feaadb1e$var$defaultTransform).on("wheel.zoom", wheeled).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    zoom.transform = function(collection, transform, point, event) {
        var selection = collection.selection ? collection.selection() : collection;
        selection.property("__zoom", $b0a81369feaadb1e$var$defaultTransform);
        if (collection !== selection) schedule(collection, transform, point, event);
        else selection.interrupt().each(function() {
            gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
        });
    };
    zoom.scaleBy = function(selection, k, p, event) {
        zoom.scaleTo(selection, function() {
            var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return k0 * k1;
        }, p, event);
    };
    zoom.scaleTo = function(selection, k, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
        }, p, event);
    };
    zoom.translateBy = function(selection, x, y, event) {
        zoom.transform(selection, function() {
            return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
        }, null, event);
    };
    zoom.translateTo = function(selection, x, y, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
            return constrain((0, $7iDKc.identity).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
        }, p, event);
    };
    function scale(transform, k) {
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
        return k === transform.k ? transform : new (0, $7iDKc.Transform)(k, transform.x, transform.y);
    }
    function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : new (0, $7iDKc.Transform)(transform.k, x, y);
    }
    function centroid(extent) {
        return [
            (+extent[0][0] + +extent[1][0]) / 2,
            (+extent[0][1] + +extent[1][1]) / 2
        ];
    }
    function schedule(transition, transform, point, event) {
        transition.on("start.zoom", function() {
            gesture(this, arguments).event(event).start();
        }).on("interrupt.zoom end.zoom", function() {
            gesture(this, arguments).event(event).end();
        }).tween("zoom", function() {
            var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
            return function(t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                    var l = i(t), k = w / l[2];
                    t = new (0, $7iDKc.Transform)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
            };
        });
    }
    function gesture(that, args, clean) {
        return !clean && that.__zooming || new Gesture(that, args);
    }
    function Gesture(that, args) {
        this.that = that;
        this.args = args;
        this.active = 0;
        this.sourceEvent = null;
        this.extent = extent.apply(that, args);
        this.taps = 0;
    }
    Gesture.prototype = {
        event: function(event) {
            if (event) this.sourceEvent = event;
            return this;
        },
        start: function() {
            if (++this.active === 1) {
                this.that.__zooming = this;
                this.emit("start");
            }
            return this;
        },
        zoom: function(key, transform) {
            if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
            if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
            if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
            this.that.__zoom = transform;
            this.emit("zoom");
            return this;
        },
        end: function() {
            if (--this.active === 0) {
                delete this.that.__zooming;
                this.emit("end");
            }
            return this;
        },
        emit: function(type) {
            var d = (0, $8mHRd.default)(this.that).datum();
            listeners.call(type, this.that, new (0, $eUaWk.default)(type, {
                sourceEvent: this.sourceEvent,
                target: zoom,
                type: type,
                transform: this.that.__zoom,
                dispatch: listeners
            }), d);
        }
    };
    function wheeled(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, $6xNHt.default)(event);
        // If the mouse is in the same location as before, reuse it.
        // If there were recent wheel events, reset the wheel idle timeout.
        if (g.wheel) {
            if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
            clearTimeout(g.wheel);
        } else if (t.k === k) return;
        else {
            g.mouse = [
                p,
                t.invert(p)
            ];
            (0, $96buf.default)(this);
            g.start();
        }
        (0, $4U5Zm.default)(event);
        g.wheel = setTimeout(wheelidled, wheelDelay);
        g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
        function wheelidled() {
            g.wheel = null;
            g.end();
        }
    }
    function mousedowned(event, ...args) {
        if (touchending || !filter.apply(this, arguments)) return;
        var g = gesture(this, args, true).event(event), v = (0, $8mHRd.default)(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, $6xNHt.default)(event, currentTarget), currentTarget = event.currentTarget, x0 = event.clientX, y0 = event.clientY;
        (0, $bN3To.default)(event.view);
        (0, $4U5Zm.nopropagation)(event);
        g.mouse = [
            p,
            this.__zoom.invert(p)
        ];
        (0, $96buf.default)(this);
        g.start();
        function mousemoved(event) {
            (0, $4U5Zm.default)(event);
            if (!g.moved) {
                var dx = event.clientX - x0, dy = event.clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
            }
            g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, $6xNHt.default)(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
        }
        function mouseupped(event) {
            v.on("mousemove.zoom mouseup.zoom", null);
            (0, $bN3To.yesdrag)(event.view, g.moved);
            (0, $4U5Zm.default)(event);
            g.event(event).end();
        }
    }
    function dblclicked(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var t0 = this.__zoom, p0 = (0, $6xNHt.default)(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
        (0, $4U5Zm.default)(event);
        if (duration > 0) (0, $8mHRd.default)(this).transition().duration(duration).call(schedule, t1, p0, event);
        else (0, $8mHRd.default)(this).call(zoom.transform, t1, p0, event);
    }
    function touchstarted(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
        (0, $4U5Zm.nopropagation)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $6xNHt.default)(t, this);
            p = [
                p,
                this.__zoom.invert(p),
                t.identifier
            ];
            if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
            else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
        }
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        if (started) {
            if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                touchstarting = null;
            }, touchDelay);
            (0, $96buf.default)(this);
            g.start();
        }
    }
    function touchmoved(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
        (0, $4U5Zm.default)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $6xNHt.default)(t, this);
            if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
            else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
        }
        t = g.that.__zoom;
        if (g.touch1) {
            var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
            t = scale(t, Math.sqrt(dp / dl));
            p = [
                (p0[0] + p1[0]) / 2,
                (p0[1] + p1[1]) / 2
            ];
            l = [
                (l0[0] + l1[0]) / 2,
                (l0[1] + l1[1]) / 2
            ];
        } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
        else return;
        g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
    }
    function touchended(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
        (0, $4U5Zm.nopropagation)(event);
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, touchDelay);
        for(i = 0; i < n; ++i){
            t = touches[i];
            if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
            else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
        }
        if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
        if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
        else {
            g.end();
            // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
            if (g.taps === 2) {
                t = (0, $6xNHt.default)(t, this);
                if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                    var p = (0, $8mHRd.default)(this).on("dblclick.zoom");
                    if (p) p.apply(this, arguments);
                }
            }
        }
    }
    zoom.wheelDelta = function(_) {
        return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, $4Es4f.default)(+_), zoom) : wheelDelta;
    };
    zoom.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $4Es4f.default)(!!_), zoom) : filter;
    };
    zoom.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $4Es4f.default)(!!_), zoom) : touchable;
    };
    zoom.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $4Es4f.default)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), zoom) : extent;
    };
    zoom.scaleExtent = function(_) {
        return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
            scaleExtent[0],
            scaleExtent[1]
        ];
    };
    zoom.translateExtent = function(_) {
        return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
            [
                translateExtent[0][0],
                translateExtent[0][1]
            ],
            [
                translateExtent[1][0],
                translateExtent[1][1]
            ]
        ];
    };
    zoom.constrain = function(_) {
        return arguments.length ? (constrain = _, zoom) : constrain;
    };
    zoom.duration = function(_) {
        return arguments.length ? (duration = +_, zoom) : duration;
    };
    zoom.interpolate = function(_) {
        return arguments.length ? (interpolate = _, zoom) : interpolate;
    };
    zoom.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? zoom : value;
    };
    zoom.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
    };
    zoom.tapDistance = function(_) {
        return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
    };
    return zoom;
}

});
parcelRegister("8u0ed", function(module, exports) {

$parcel$export(module.exports, "default", () => $62d14d651755ad24$export$2e2bcd8739ae039);
var $62d14d651755ad24$var$epsilon2 = 1e-12;
function $62d14d651755ad24$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $62d14d651755ad24$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $62d14d651755ad24$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $62d14d651755ad24$export$2e2bcd8739ae039 = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < $62d14d651755ad24$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $62d14d651755ad24$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $62d14d651755ad24$var$tanh(rho * s + r0) - $62d14d651755ad24$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $62d14d651755ad24$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);

});

parcelRegister("4Es4f", function(module, exports) {

$parcel$export(module.exports, "default", () => $3630ab73f6216cd0$export$2e2bcd8739ae039);
var $3630ab73f6216cd0$export$2e2bcd8739ae039 = (x)=>()=>x;

});

parcelRegister("eUaWk", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad9ec80ebe6e1438$export$2e2bcd8739ae039);
function $ad9ec80ebe6e1438$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, transform: transform, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        transform: {
            value: transform,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}

});

parcelRegister("7iDKc", function(module, exports) {

$parcel$export(module.exports, "Transform", () => $55090b392153f0d5$export$563a914cafbdc389);
$parcel$export(module.exports, "identity", () => $55090b392153f0d5$export$f0954fd7d5368655);
function $55090b392153f0d5$export$563a914cafbdc389(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
$55090b392153f0d5$export$563a914cafbdc389.prototype = {
    constructor: $55090b392153f0d5$export$563a914cafbdc389,
    scale: function(k) {
        return k === 1 ? this : new $55090b392153f0d5$export$563a914cafbdc389(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new $55090b392153f0d5$export$563a914cafbdc389(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $55090b392153f0d5$export$f0954fd7d5368655 = new $55090b392153f0d5$export$563a914cafbdc389(1, 0, 0);
$55090b392153f0d5$export$2e2bcd8739ae039.prototype = $55090b392153f0d5$export$563a914cafbdc389.prototype;
function $55090b392153f0d5$export$2e2bcd8739ae039(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return $55090b392153f0d5$export$f0954fd7d5368655;
    return node.__zoom;
}

});

parcelRegister("4U5Zm", function(module, exports) {

$parcel$export(module.exports, "nopropagation", () => $392109a37f19436b$export$2e2561858db9bf47);
$parcel$export(module.exports, "default", () => $392109a37f19436b$export$2e2bcd8739ae039);
function $392109a37f19436b$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $392109a37f19436b$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}

});




parcelRequire("6uGhf");
var $wUwgT = parcelRequire("wUwgT");
var $aSvrg = parcelRequire("aSvrg");
parcelRequire("6uGhf");
var $7zw1L = parcelRequire("7zw1L");
function $4e532f8b99c456b2$export$2e2bcd8739ae039(rgb) {
    const c = (0, $7zw1L.default)(rgb);
    if (!c) return false;
    const { r: r, g: g, b: b } = c.rgb();
    // Relative luminance (WCAG)
    const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
    return luminance < 0.55;
}


const $01940d7d967ef149$var$colors = [
    '#3661AD',
    '#ffffff',
    '#D82129'
];
function $01940d7d967ef149$export$2e2bcd8739ae039(elementId = 'win-prob') {
    const cells = Array.from(document.querySelectorAll(`#${elementId} td[data-situation]`));
    const values = cells.map((c)=>Number(c.textContent)).filter((v)=>!Number.isNaN(v));
    if (!values.length) return;
    let colorScale;
    if (elementId.includes('win-prob')) colorScale = (0, $wUwgT.default)($01940d7d967ef149$var$colors).domain([
        0,
        50,
        100
    ]);
    else {
        const min = Math.min(...values);
        const max = Math.max(...values);
        const mid = (min + max) / 2;
        colorScale = (0, $aSvrg.default)($01940d7d967ef149$var$colors).domain([
            min,
            mid,
            max
        ]);
    }
    cells.forEach((cell)=>{
        const cellEl = cell;
        const value = Number(cell.textContent);
        if (Number.isNaN(value)) return;
        const bg = colorScale(value);
        cellEl.style.backgroundColor = bg;
        cellEl.style.color = (0, $4e532f8b99c456b2$export$2e2bcd8739ae039)(bg) ? '#fff' : '#1a1a1a';
    });
}


function $fd390bf93c17e258$export$4cd3148c6978c97c() {
    // Inning + half
    const inningInput = document.querySelector('input[name="inning"]:checked');
    const situation = document.querySelector('select[name="situation"]')?.value ?? null;
    const inning = inningInput ? Number(inningInput.value) : null;
    const half = inningInput ? inningInput.dataset.half : null;
    // Outs / Balls / Strikes
    const outs = Number(document.querySelector('input[name="outs"]:checked')?.value ?? 0);
    const ballsInput = document.querySelector('input[name="balls"]:checked');
    const balls = ballsInput ? Number(ballsInput.value) : null;
    const strikesInput = document.querySelector('input[name="strikes"]:checked');
    const strikes = strikesInput ? Number(strikesInput.value) : null;
    // Run differential
    const runDiff = Number(document.querySelector('input[name="diff"]:checked')?.value ?? 0) || 0;
    // Runners
    const runners = {
        '1b': false,
        '2b': false,
        '3b': false
    };
    document.querySelectorAll('.base').forEach((base)=>{
        const { id: id } = base // e.g. "runner-1b"
        ;
        if (!id) return;
        const match = id.match(/-(1b|2b|3b)$/);
        if (!match) return;
        const key = match[1];
        runners[key] = base.dataset.selected === 'true';
    });
    const isPerspectiveChecked = document.querySelector('#perspective-toggle')?.checked;
    // Use it in a ternary
    const perspective = isPerspectiveChecked ? 'bat' : 'home';
    const returnValue = {
        inning: inning,
        half: half,
        outs: outs,
        balls: balls,
        strikes: strikes,
        situation: situation,
        run_diff: runDiff,
        runners: runners,
        perspective: perspective
    };
    return returnValue;
}
function $fd390bf93c17e258$export$f3fffda27536fb8b() {
    // Reset Inning to Top of the 1st
    const firstInningTop = document.querySelector('input[name="inning"][value="1"]');
    if (firstInningTop) firstInningTop.checked = true;
    // Reset Score (Run Differential) to 0
    const zeroDiff = document.querySelector('input[name="diff"][value="0"]');
    if (zeroDiff) zeroDiff.checked = true;
    // Reset Count: 0 Outs, 0 Balls, 0 Strikes
    const countSelectors = [
        'input[name="outs"][value="0"]',
        'input[name="balls"][value="0"]',
        'input[name="strikes"][value="0"]'
    ];
    countSelectors.forEach((selector)=>{
        const el = document.querySelector(selector);
        if (el) el.checked = true;
    });
    // Reset Situation Dropdown
    const situationSelect = document.querySelector('select[name="situation"]');
    if (situationSelect) situationSelect.value = '';
    // Clear Runners
    document.querySelectorAll('.base').forEach((base)=>{
        base.setAttribute('data-selected', 'false');
        base.setAttribute('aria-pressed', 'false');
        base.classList.remove('base-selected');
        base.classList.add('base-hatched');
    });
    // Reset Perspective Toggle
    const perspectiveToggle = document.querySelector('#perspective-toggle');
    if (perspectiveToggle) perspectiveToggle.checked = true;
}
function $fd390bf93c17e258$export$94c953b1998f7304(situationUpdate) {
    const situation = $fd390bf93c17e258$export$4cd3148c6978c97c();
    let { runners: runners, run_diff: run_diff, inning: inning, half: half, outs: outs, detailed_event_code: detailed_event_code } = situation;
    if (situationUpdate) {
        run_diff = situationUpdate?.next_bat_score;
        outs = situationUpdate.next_outs;
        inning = situationUpdate.next_inning;
        half = situationUpdate.next_bottom_top;
        runners = $fd390bf93c17e258$var$computeRunners(situationUpdate.next_bases_cd || 0);
        detailed_event_code = situationUpdate.detailed_event_code || '';
    }
    let scoreText = '';
    if (run_diff !== null && run_diff !== undefined) {
        if (run_diff === 0) scoreText = 'Tied';
        else if (run_diff > 0) scoreText = `Batting team up ${Math.abs(run_diff || 0)}`;
        else if (run_diff < 0) scoreText = `Batting team down ${Math.abs(run_diff || 0)}`;
    }
    const inningText = `${half?.substring(0, 1)}${inning}`;
    let runnerText = '';
    if (runners) {
        const r1 = runners['1b'];
        const r2 = runners['2b'];
        const r3 = runners['3b'];
        const activeRunnersCount = [
            r1,
            r2,
            r3
        ].filter(Boolean).length;
        if (activeRunnersCount === 3) runnerText = 'bases loaded';
        else if (activeRunnersCount === 0) runnerText = 'bases empty';
        else {
            const bases = [];
            if (r1) bases.push('1st');
            if (r2) bases.push('2nd');
            if (r3) bases.push('3rd');
            const label = bases.length > 1 ? 'runners' : 'runner';
            runnerText = `${label} on ${bases.join(' and ')}`;
        }
    }
    return `${detailed_event_code ? `<b><u>${detailed_event_code}</b></u><br/>` : ``}${scoreText}, ${inningText}, ${runnerText}, ${outs} out, `;
}
function $fd390bf93c17e258$var$computeRunners(bases_cd) {
    return {
        '1b': bases_cd % 2 === 1,
        '2b': Math.floor(bases_cd / 2) % 2 === 1,
        '3b': Math.floor(bases_cd / 4) % 2 === 1
    };
}


function $e6fb16dce6b8515a$export$2e2bcd8739ae039(row, shouldFlip, scoreDiff) {
    // scoreDiff is negative on the left (-5 to -1) and positive on the right (1 to 5)
    // If perspective is 'bat', negative diffs mean "Batting team leading"
    // If perspective is 'bat' and it's the Bottom (Home bats), a Batting Lead is actually a Home Lead.
    let key;
    const absDiff = Math.abs(scoreDiff);
    if (scoreDiff === 0) key = 'bat_wins_0';
    else if (shouldFlip) // Left side (-5) becomes Home +5, Right side (+5) becomes Home -5
    key = scoreDiff < 0 ? `bat_wins_${absDiff}` : `bat_wins_minus_${absDiff}`;
    else // Standard behavior
    key = scoreDiff < 0 ? `bat_wins_minus_${absDiff}` : `bat_wins_${absDiff}`;
    return (100 * Number(row[key] ?? 0)).toFixed(1);
}


function $192107a7e84dd696$export$2e2bcd8739ae039(data) {
    if (!data.length) console.warn('No leverage index data returned');
    const gameSituation = (0, $fd390bf93c17e258$export$4cd3148c6978c97c)();
    // Determine if we need to flip the columns
    const shouldFlip = false;
    /* gameSituation.perspective === 'bat' &&
        ((gameSituation.half === 'Top' && gameSituation.run_diff < 0) ||
            (gameSituation.half === 'Bottom' && gameSituation.run_diff >= 0)) */ // Set Dynamic Headers
    const leftHeader = gameSituation.perspective === 'bat' ? 'Batting Team Losing' : 'Visiting Team';
    const rightHeader = gameSituation.perspective === 'bat' ? 'Batting Team Winning' : 'Home Team';
    const footer = gameSituation.perspective === 'bat' ? 'Batting' : 'Home';
    const table = `
<table id="tbl-win-prob">
  <thead>
    <tr class="secondary-header">
      <th colspan="4"></th>
      <th colspan="5"  class="th-title-header">${leftHeader}</th>
      <th></th>
      <th colspan="5"  class="th-title-header">${rightHeader}</th>
    </tr>    
    <tr class="tr-component-row">
      <th class="th-component-header align-center">Inning</th>
      <th class="th-component-header align-center">Top/Bot</th>
      <th class="th-component-header align-center">Outs</th>
      <th class="th-component-header align-center">Runners</th>
      <th class="th-component-header align-center border-left" data-diff="-5">-5</th>
      <th class="th-component-header align-center" data-diff="-4">-4</th>
      <th class="th-component-header align-center" data-diff="-3">-3</th>
      <th class="th-component-header align-center" data-diff="-2">-2</th>
      <th class="th-component-header align-center" data-diff="-1">-1</th>
      <th class="th-component-header align-center border-left" data-diff="0">Tie</th>
      <th class="th-component-header align-center border-left" data-diff="1">+1</th>
      <th class="th-component-header align-center" data-diff="2">+2</th>
      <th class="th-component-header align-center" data-diff="3">+3</th>
      <th class="th-component-header align-center" data-diff="4">+4</th>
      <th class="th-component-header align-center border-right" data-diff="5">+5</th>
    </tr>
  </thead>
  <tbody>
    ${data.map((row)=>{
        const bases = row.bases_cd ?? '';
        return `
      <tr class="default-table-row" data-bases-cd="${bases}">
        <td class="tr-data align-center">${row.inning}</td>
        <td class="tr-data align-center">${row.bottom_top}</td>
        <td class="tr-data align-center">${row.outs}</td>
        <td class="tr-data align-center">${row.bases}</td>

<td class="tr-data align-center border-left" data-situation="-5">${(0, $e6fb16dce6b8515a$export$2e2bcd8739ae039)(row, shouldFlip, -5)}</td>
<td class="tr-data align-center" data-situation="-4">${(0, $e6fb16dce6b8515a$export$2e2bcd8739ae039)(row, shouldFlip, -4)}</td>
<td class="tr-data align-center" data-situation="-3">${(0, $e6fb16dce6b8515a$export$2e2bcd8739ae039)(row, shouldFlip, -3)}</td>
<td class="tr-data align-center" data-situation="-2">${(0, $e6fb16dce6b8515a$export$2e2bcd8739ae039)(row, shouldFlip, -2)}</td>
<td class="tr-data align-center" data-situation="-1">${(0, $e6fb16dce6b8515a$export$2e2bcd8739ae039)(row, shouldFlip, -1)}</td>
<td class="tr-data align-center border-left" data-situation="0">${(0, $e6fb16dce6b8515a$export$2e2bcd8739ae039)(row, shouldFlip, 0)}</td>
<td class="tr-data align-center border-left" data-situation="1">${(0, $e6fb16dce6b8515a$export$2e2bcd8739ae039)(row, shouldFlip, 1)}</td>
<td class="tr-data align-center" data-situation="2">${(0, $e6fb16dce6b8515a$export$2e2bcd8739ae039)(row, shouldFlip, 2)}</td>
<td class="tr-data align-center" data-situation="3">${(0, $e6fb16dce6b8515a$export$2e2bcd8739ae039)(row, shouldFlip, 3)}</td>
<td class="tr-data align-center" data-situation="4">${(0, $e6fb16dce6b8515a$export$2e2bcd8739ae039)(row, shouldFlip, 4)}</td>
<td class="tr-data align-center border-right" data-situation="5">${(0, $e6fb16dce6b8515a$export$2e2bcd8739ae039)(row, shouldFlip, 5)}</td>
      </tr>`;
    }).join('')}
    <tr>
    <td colspan="4"></td>
    <td colspan="11" class="footer-title">Probability ${footer} Team Wins</td>
    </tr>        
  </tbody>
</table>
`;
    const el = document.getElementById('game-strategy-explorer-table-wrapper');
    if (el) el.innerHTML = table;
    (0, $01940d7d967ef149$export$2e2bcd8739ae039)('tbl-win-prob');
    $192107a7e84dd696$var$highlightMatchingRow((0, $fd390bf93c17e258$export$4cd3148c6978c97c)());
    const summaryEl = document.getElementById('summary');
    if (summaryEl) {
        const winProb = document.querySelector('#tbl-win-prob .cell-highlight');
        summaryEl.innerHTML = `<div><b><u>Start Situation</u></b>:<br/>${(0, $fd390bf93c17e258$export$94c953b1998f7304)(null)} <strong><span id="current-win-pct">${winProb?.innerHTML}</span>% WP for batting team</strong></div><hr class="situation-hr"></hr>`;
    }
}
function $192107a7e84dd696$var$highlightMatchingRow(situation) {
    const BASE_MASK = {
        '1b': 1,
        '2b': 2,
        '3b': 4
    };
    document.querySelectorAll("#game-strategy-explorer-table-wrapper .tr-data, #game-strategy-explorer-table-wrapper .cell-highlight").forEach((el)=>el.classList.remove('cell-highlight'));
    const activeBasesCd = Object.entries(situation?.runners ?? {})?.reduce((sum, [base, on])=>{
        if (!on) return sum;
        return sum + BASE_MASK[base];
    }, 0);
    const rows = document.querySelectorAll('#game-strategy-explorer-table-wrapper table tbody tr');
    const shouldFlip = false;
    /* situation.perspective === 'bat' &&
        situation.half === 'Bottom' &&
        situation.run_diff >= 0 */ let runDiff = situation.run_diff ?? 0;
    if (shouldFlip) runDiff *= -1;
    rows.forEach((row)=>{
        const rowBasesCd = Number(row.dataset.basesCd ?? -1);
        if (rowBasesCd === activeBasesCd) {
            row.classList.add('row-highlight');
            const cell = row.querySelector(`[data-situation="${runDiff}"]`);
            cell?.removeAttribute('style');
            cell?.classList.add('cell-highlight');
        }
    });
}





function $ff0e5ba3a051de30$export$2e2bcd8739ae039(data) {
    if (!data.length) console.warn('No leverage index data returned');
    const gameSituation = (0, $fd390bf93c17e258$export$4cd3148c6978c97c)();
    // Determine if we need to flip the columns
    const shouldFlip = false;
    /* gameSituation.perspective === 'bat' &&
        ((gameSituation.half === 'Top' && gameSituation.run_diff < 0) ||
            (gameSituation.half === 'Bottom' && gameSituation.run_diff >= 0)) */ // Set Dynamic Headers
    const leftHeader = gameSituation.perspective === 'bat' ? 'Batting Team Losing' : 'Visiting Team';
    const rightHeader = gameSituation.perspective === 'bat' ? 'Batting Team Winning' : 'Home Team';
    const footer = gameSituation.perspective === 'bat' ? 'Batting' : 'Home';
    const table = `
<table id="tbl-win-prob-count">
  <thead>
    <tr class="secondary-header">
      <th colspan="5"></th>
      <th colspan="5"  class="th-title-header">${leftHeader}</th>
      <th></th>
      <th colspan="5"  class="th-title-header">${rightHeader}</th>
    </tr>  
    <tr class="tr-component-row">
      <th class="th-component-header align-center">Inning</th>
      <th class="th-component-header align-center">Top/Bot</th>
      <th class="th-component-header align-center">Outs</th>
      <th class="th-component-header align-center">Runners</th>
      <th class="th-component-header align-center">Count</th>
      <th class="th-component-header align-center border-left" data-count="-5">+5</th>
      <th class="th-component-header align-center" data-count="-4">+4</th>
      <th class="th-component-header align-center" data-count="-3">+3</th>
      <th class="th-component-header align-center" data-count="-2">+2</th>
      <th class="th-component-header align-center" data-count="-1">+1</th>
      <th class="th-component-header align-center border-left" data-count="0">Tie</th>
      <th class="th-component-header align-center border-left" data-count="1">+1</th>
      <th class="th-component-header align-center" data-count="2">+2</th>
      <th class="th-component-header align-center" data-count="3">+3</th>
      <th class="th-component-header align-center" data-count="4">+4</th>
      <th class="th-component-header align-center border-right" data-count="5">+5</th>
    </tr>
  </thead>
  <tbody>
    ${data.map((row)=>`
      <tr class="default-table-row" data-count="${row.ball_count}-${row.strike_count}">
        <td class="tr-data align-center">${row.inning}</td>
        <td class="tr-data align-center">${row.bottom_top}</td>
        <td class="tr-data align-center">${row.outs}</td>
        <td class="tr-data align-center">${row.bases}</td>
        <td class="tr-data align-center">${row.ball_count}-${row.strike_count}</td>
        <td class="tr-data align-center border-left" data-situation="-5">${(0, $e6fb16dce6b8515a$export$2e2bcd8739ae039)(row, shouldFlip, -5)}</td>
        <td class="tr-data align-center" data-situation="-4">${(0, $e6fb16dce6b8515a$export$2e2bcd8739ae039)(row, shouldFlip, -4)}</td>
        <td class="tr-data align-center" data-situation="-3">${(0, $e6fb16dce6b8515a$export$2e2bcd8739ae039)(row, shouldFlip, -3)}</td>
        <td class="tr-data align-center" data-situation="-2">${(0, $e6fb16dce6b8515a$export$2e2bcd8739ae039)(row, shouldFlip, -2)}</td>
        <td class="tr-data align-center" data-situation="-1">${(0, $e6fb16dce6b8515a$export$2e2bcd8739ae039)(row, shouldFlip, -1)}</td>
        <td class="tr-data align-center border-left" data-situation="0">${(0, $e6fb16dce6b8515a$export$2e2bcd8739ae039)(row, shouldFlip, 0)}</td>
        <td class="tr-data align-center border-left" data-situation="1">${(0, $e6fb16dce6b8515a$export$2e2bcd8739ae039)(row, shouldFlip, 1)}</td>
        <td class="tr-data align-center" data-situation="2">${(0, $e6fb16dce6b8515a$export$2e2bcd8739ae039)(row, shouldFlip, 2)}</td>
        <td class="tr-data align-center" data-situation="3">${(0, $e6fb16dce6b8515a$export$2e2bcd8739ae039)(row, shouldFlip, 3)}</td>
        <td class="tr-data align-center" data-situation="4">${(0, $e6fb16dce6b8515a$export$2e2bcd8739ae039)(row, shouldFlip, 4)}</td>
        <td class="tr-data align-center border-right" data-situation="5">${(0, $e6fb16dce6b8515a$export$2e2bcd8739ae039)(row, shouldFlip, 5)}</td>
      </tr>`).join('')}
    <tr>
    <td colspan="5"></td>
    <td colspan="11" class="footer-title">Probability ${footer} Team Wins</td>
    </tr>
  </tbody>
</table>
`;
    const el = document.getElementById('game-strategy-explorer-by-count-table-wrapper');
    if (el) el.innerHTML = table;
    (0, $01940d7d967ef149$export$2e2bcd8739ae039)('tbl-win-prob-count');
    $ff0e5ba3a051de30$var$highlightMatchingRowByCount(gameSituation);
}
function $ff0e5ba3a051de30$var$highlightMatchingRowByCount(situation) {
    // Clear previous highlights ONLY in the by-count table
    document.querySelectorAll('#game-strategy-explorer-by-count-table-wrapper .cell-highlight').forEach((el)=>el.classList.remove('cell-highlight'));
    if (situation.balls == null || situation.strikes == null) return;
    const countKey = `${situation.balls}-${situation.strikes}`;
    const rows = document.querySelectorAll('#game-strategy-explorer-by-count-table-wrapper table tbody tr');
    const shouldFlip = false;
    /* situation.perspective === 'bat' &&
        situation.half === 'Bottom' &&
        situation.run_diff >= 0 */ let runDiff = situation.run_diff ?? 0;
    if (shouldFlip) runDiff *= -1;
    rows.forEach((row)=>{
        if (row.dataset.count !== countKey) return;
        const cell = row.querySelector(`[data-situation="${runDiff}"]`);
        if (cell) cell.classList.add('cell-highlight');
    });
}




function $89c8a99dc043190f$export$2e2bcd8739ae039(data) {
    if (!data.length) console.warn('No run expectancy data returned');
    const table = `
<table id="tbl-run-exp-by-count-selected">
  <thead>
    <tr><th></th></tr>
    <tr class="tr-component-row">
      <th class="th-component-header align-center">Runners</th>
      <th class="th-component-header align-center">Count</th>
      <th class="th-component-header align-center" data-outs="0">0 Outs</th>
      <th class="th-component-header align-center" data-outs="1">1 Out</th>
      <th class="th-component-header align-center" data-outs="2">2 Outs</th>
    </tr>
  </thead>
  <tbody>
    ${data.map((row)=>{
        const count = `${row.ball_count}-${row.strike_count}`;
        return `
<tr
  class="default-table-row" 
  data-count="${count}"
  data-runners="${row.runners_on_cd}"
>
  <td class="tr-data align-center">${row.bases}</td>
  <td class="tr-data align-center">${count}</td>
  <td class="tr-data align-center" data-situation="0">${row.run_expectancy_0_out != null ? row.run_expectancy_0_out.toFixed(3) : ''}</td>
  <td class="tr-data align-center" data-situation="1">${row.run_expectancy_1_out != null ? row.run_expectancy_1_out.toFixed(3) : ''}</td>
  <td class="tr-data align-center" data-situation="2">${row.run_expectancy_2_out != null ? row.run_expectancy_2_out.toFixed(3) : ''}</td>
</tr>`;
    }).join('')}
  </tbody>
</table>
`;
    const el = document.getElementById('run-exp-count');
    if (el) el.innerHTML = table;
    $89c8a99dc043190f$var$highlightMatchingRowByCountSelected((0, $fd390bf93c17e258$export$4cd3148c6978c97c)());
    (0, $01940d7d967ef149$export$2e2bcd8739ae039)('tbl-run-exp-by-count-selected');
}
function $89c8a99dc043190f$var$highlightMatchingRowByCountSelected(situation) {
    // Clear previous highlights ONLY in the by-count table
    document.querySelectorAll('#run-exp-count .cell-highlight').forEach((el)=>el.classList.remove('cell-highlight'));
    if (situation.balls == null || situation.strikes == null) return;
    const countKey = `${$89c8a99dc043190f$var$computeBasesCd(situation.runners)}`;
    const rows = document.querySelectorAll('#run-exp-count table tbody tr');
    rows.forEach((row)=>{
        if (row.dataset.runners !== countKey) return;
        const cell = row.querySelector(`[data-situation="${situation.outs}"]`);
        if (cell) cell.classList.add('cell-highlight');
    });
}
function $89c8a99dc043190f$var$computeBasesCd(runners = {}) {
    let bases_cd = 0;
    if (runners['1b']) bases_cd += 1;
    if (runners['2b']) bases_cd += 2;
    if (runners['3b']) bases_cd += 4;
    return bases_cd;
}




function $e67b3cd0bbaaeaf9$export$2e2bcd8739ae039(data) {
    if (!data.length) console.warn('No run expectancy by count data returned');
    const table = `
<table id="tbl-run-exp-by-runner-selected">
  <thead>
    <tr><th></th></tr>
    <tr class="tr-component-row">
      <th class="th-component-header align-center">Runners</th>
      <th class="th-component-header align-center">Outs</th>
      <th class="th-component-header align-center">Balls</th>
      <th class="th-component-header align-center" data-strikes="0">0 Strikes</th>
      <th class="th-component-header align-center" data-strikes="1">1 Strike</th>
      <th class="th-component-header align-center" data-strikes="2">2 Strikes</th>
    </tr>
  </thead>
  <tbody>
    ${data.map((row)=>`
<tr class="default-table-row" data-balls="${row.balls}">
  <td class="tr-data align-center">${row.bases}</td>
  <td class="tr-data align-center">${row.outs}</td>
  <td class="tr-data align-center">${row.balls}</td>
  <td class="tr-data align-center" data-situation="${row.balls}0">${row.run_exp_strikes_0 != null ? row.run_exp_strikes_0.toFixed(3) : ''}</td>
  <td class="tr-data align-center" data-situation="${row.balls}1">${row.run_exp_strikes_1 != null ? row.run_exp_strikes_1.toFixed(3) : ''}</td>
  <td class="tr-data align-center" data-situation="${row.balls}2">${row.run_exp_strikes_2 != null ? row.run_exp_strikes_2.toFixed(3) : ''}</td>
</tr>`).join('')}
  </tbody>
</table>
`;
    const el = document.getElementById('run-exp-runner');
    if (el) el.innerHTML = table;
    (0, $01940d7d967ef149$export$2e2bcd8739ae039)('tbl-run-exp-by-runner-selected');
    $e67b3cd0bbaaeaf9$var$highlightRunExpectancyRowByRunnerSelected((0, $fd390bf93c17e258$export$4cd3148c6978c97c)());
}
function $e67b3cd0bbaaeaf9$var$highlightRunExpectancyRowByRunnerSelected(situation) {
    // Clear previous highlights ONLY in the by-count table
    document.querySelectorAll('#run-exp-runner .cell-highlight').forEach((el)=>el.classList.remove('cell-highlight'));
    if (situation.balls == null || situation.strikes == null) return;
    const countKey = `${situation.balls}`;
    const rows = document.querySelectorAll('#run-exp-runner table tbody tr');
    rows.forEach((row)=>{
        if (row.dataset.balls !== countKey) return;
        const cell = row.querySelector(`[data-situation="${countKey}${situation.strikes}"]`);
        if (cell) cell.classList.add('cell-highlight');
    });
}


function $d4d76553d4e85195$export$2e2bcd8739ae039() {
    const situationEl = document.getElementById('situation');
    if (situationEl) {
        const situationValue = situationEl.value;
        if (situationValue && situationValue.trim() !== '') return true;
    }
    return false;
}



function $2e9bdd24922687a7$export$cc72251b892b19fb(rows) {
    const map = new Map();
    rows.forEach((d)=>{
        const key = `${d.runners_on_cd}|${d.ball_count}|${d.strike_count}`;
        if (!map.has(key)) map.set(key, {
            runners_on_cd: d.runners_on_cd,
            bases: d.bases,
            outs: d.outs,
            ball_count: d.ball_count,
            strike_count: d.strike_count,
            run_expectancy_0_out: null,
            run_expectancy_1_out: null,
            run_expectancy_2_out: null
        });
        const row = map.get(key)// Use ! because we know it was just set or existed
        ;
        const outKey = `run_expectancy_${d.outs}_out`;
        row[outKey] = d.run_expectancy;
    });
    return Array.from(map.values());
}
function $2e9bdd24922687a7$export$807d82b8b4ae4793(data) {
    const balls = [
        0,
        1,
        2,
        3
    ];
    const strikes = [
        0,
        1,
        2
    ];
    // Index run expectancy by count string: "B-S"
    const lookup = new Map(data.map((d)=>[
            `${d.ball_count}-${d.strike_count}`,
            d.run_expectancy
        ]));
    // Index bases by ball count (first match wins)
    const basesByBall = new Map();
    data.forEach((d)=>{
        if (!basesByBall.has(d.ball_count)) basesByBall.set(d.ball_count, d.bases);
    });
    const { outs: outs } = data?.[0] ?? 0;
    return balls.map((ballCount)=>{
        // Initialize the row with explicit types
        const row = {
            outs: outs,
            balls: ballCount,
            bases: basesByBall.get(ballCount) ?? '',
            run_exp_strikes_0: null,
            run_exp_strikes_1: null,
            run_exp_strikes_2: null
        };
        strikes.forEach((strikeCount)=>{
            const key = `run_exp_strikes_${strikeCount}`;
            row[key] = lookup.get(`${ballCount}-${strikeCount}`) ?? null;
        });
        return row;
    });
}


function $b21e936f27ab964f$export$2e2bcd8739ae039() {
    const qs = new URLSearchParams(window.location.search);
    const jsonString = qs.get('qs');
    const ddlType = qs.get('type');
    if (jsonString) try {
        if (ddlType) {
            const select = document.querySelector('select[name="ddlType"]');
            if (select) {
                select.value = ddlType;
                const selectedText = select.options[select.selectedIndex]?.text;
                const label = document.getElementById('lblType');
                if (label) label.innerHTML = selectedText;
            }
        }
        // Parse the JSON into our GameSituation type
        const params = JSON.parse(jsonString);
        // 1. Inning + Half (Radio Buttons)
        // Note: We use optional chaining because JSON values might be null/undefined
        if (params.inning !== null && params.half) {
            const selector = `input[name="inning"][value="${params.inning}"][data-half="${params.half}"]`;
            const input = document.querySelector(selector);
            if (input) input.checked = true;
        }
        // 2. Situation (Select Dropdown)
        if (params.situation) {
            const select = document.querySelector('select[name="situation"]');
            if (select) select.value = params.situation;
        }
        // 3. Outs / Balls / Strikes / Run Diff (Radio Buttons)
        const setRadioByValue = (name, value)=>{
            if (value === null || value === undefined) return;
            const input = document.querySelector(`input[name="${name}"][value="${value}"]`);
            if (input) input.checked = true;
        };
        setRadioByValue('outs', params.outs);
        setRadioByValue('balls', params.balls);
        setRadioByValue('strikes', params.strikes);
        setRadioByValue('diff', params.run_diff);
        // 4. Runners (Data Attributes)
        // Accessing the nested 'runners' object from GameSituation
        if (params.runners) {
            const bases = [
                '1b',
                '2b',
                '3b'
            ];
            bases.forEach((base)=>{
                const isRunnerPresent = params.runners[base];
                const baseElement = document.getElementById(`runner-${base}`);
                if (baseElement) {
                    baseElement.dataset.selected = 'false';
                    if (isRunnerPresent) {
                        baseElement.dataset.selected = 'true';
                        baseElement.setAttribute('aria-pressed', 'true');
                        baseElement.classList.add('base-selected');
                    }
                }
            });
        }
        // 4. Perspective
        if (params.perspective && params.perspective === 'bat') {
            const checkbox = document.querySelector('input[name="perspective"]');
            if (checkbox) checkbox.checked = true;
        }
    } catch (e) {
        console.error('Failed to parse game situation JSON from URL', e);
    }
}


async function $951feb090383f654$export$2e2bcd8739ae039(query) {
    const res = await fetch(`/game-strategy-explorer?${query.toString()}`, {
        method: 'GET',
        headers: {
            Accept: 'application/json'
        }
    });
    if (!res.ok) throw new Error('Failed to fetch leverage index');
    return res.json();
}


const $b4bf367239495756$var$lblType = document.getElementById('lblType');
const $b4bf367239495756$var$ddlType = document.getElementById('ddlType');
const $b4bf367239495756$var$winProbButton = document.getElementById('btnWinProbability');
const $b4bf367239495756$var$winProbCountButton = document.getElementById('btnWinProbabilityCount');
const $b4bf367239495756$var$balls = document.getElementById('balls');
const $b4bf367239495756$var$strikes = document.getElementById('strikes');
const $b4bf367239495756$var$situationContainer = document.getElementById('situation-container');
const $b4bf367239495756$var$summaryContainer = document.getElementById('summary-container');
(0, $b21e936f27ab964f$export$2e2bcd8739ae039)();
$b4bf367239495756$var$updateFormControls();
$b4bf367239495756$var$emitSituation(false);
// All requests sent through here
async function $b4bf367239495756$var$emitSituation(isSituation) {
    const gameSituation = (0, $fd390bf93c17e258$export$4cd3148c6978c97c)();
    const type = document.querySelector('select[name="ddlType"]')?.value ?? null;
    if (type === 'winexp' && isSituation) $b4bf367239495756$var$sendWinProbabilitySituationRequest(gameSituation).then((data)=>{
        $b4bf367239495756$var$appendSituationToSummary(data);
    });
    else if (type === 'winexp') {
        $b4bf367239495756$var$clearSummary();
        await $b4bf367239495756$var$sendWinProbabilityRequest(gameSituation).then((data)=>{
            (0, $192107a7e84dd696$export$2e2bcd8739ae039)(data);
        });
        gameSituation.is_by_count = true;
        await $b4bf367239495756$var$sendWinProbabilityRequest(gameSituation).then((data)=>{
            (0, $ff0e5ba3a051de30$export$2e2bcd8739ae039)(data);
        });
        $b4bf367239495756$var$sendSituationQuery();
    } else {
        $b4bf367239495756$var$sendRunExpectancyRequest(gameSituation, 'runexp-runners').then((data)=>{
            const rows = (0, $2e9bdd24922687a7$export$807d82b8b4ae4793)(data);
            (0, $e67b3cd0bbaaeaf9$export$2e2bcd8739ae039)(rows);
        });
        $b4bf367239495756$var$sendRunExpectancyRequest(gameSituation, 'runexp-count').then((data)=>{
            const rows = (0, $2e9bdd24922687a7$export$cc72251b892b19fb)(data);
            (0, $89c8a99dc043190f$export$2e2bcd8739ae039)(rows);
        });
    }
    $b4bf367239495756$var$populateUrl();
}
function $b4bf367239495756$var$appendSituationToSummary(winProbabilitySituation) {
    const currentWinPctEl = document.getElementById('current-win-pct');
    let currentWinPct = 0;
    if (currentWinPctEl) currentWinPct = Number(currentWinPctEl.innerHTML);
    const summaryEl = document.getElementById('summary-situation');
    if (!summaryEl || !winProbabilitySituation) return;
    if (winProbabilitySituation.length === 0) summaryEl.innerHTML = `<i>* No data is available for this particular situation. Please try another selection.</i>`;
    else {
        const htmlContent = winProbabilitySituation.map((winProb)=>{
            const winPct = winProb?.next_bat_wins ? winProb.next_bat_wins * 100 : 0;
            const winPctDiff = winPct - Number(currentWinPct);
            const displayPct = winPct.toFixed(1);
            let displayDiff;
            const formattedDiff = winPctDiff.toFixed(1);
            if (winPct === 0 || winPct === 100) displayDiff = '<span style="color: rgb(217, 40, 47);">GAME OVER</span>';
            else if (winPctDiff > 0) displayDiff = `<span style="color: rgb(217, 40, 47);">+${formattedDiff}</span>`;
            else if (winPctDiff < 0) displayDiff = `<span style="color: blue;">${formattedDiff}</span>`;
            else displayDiff = formattedDiff;
            return `<div>${(0, $fd390bf93c17e258$export$94c953b1998f7304)(winProb)} <strong>${displayPct}% WP ${typeof winPctDiff === 'number' ? `(${displayDiff}) ` : ``}</strong></div>`;
        }).join('');
        summaryEl.innerHTML = htmlContent;
    }
}
function $b4bf367239495756$var$populateUrl() {
    const queryString = JSON.stringify((0, $fd390bf93c17e258$export$4cd3148c6978c97c)());
    const type = document.getElementById('ddlType');
    if (type) {
        const { value: value } = type;
        // Encode the components to handle braces, quotes, and spaces
        const encodedQs = encodeURIComponent(queryString);
        const encodedType = encodeURIComponent(value);
        window.history.pushState((0, $fd390bf93c17e258$export$4cd3148c6978c97c)(), '', `/game-strategy-explorer?type=${encodedType}&qs=${encodedQs}`);
    }
}
async function $b4bf367239495756$var$sendWinProbabilityRequest(gameSituation) {
    const query = new URLSearchParams({
        type: 'winexp',
        params: JSON.stringify(gameSituation)
    });
    const data = await (0, $951feb090383f654$export$2e2bcd8739ae039)(query);
    return data;
}
async function $b4bf367239495756$var$sendWinProbabilitySituationRequest(gameSituation) {
    const query = new URLSearchParams({
        type: 'winexp-situation',
        params: JSON.stringify(gameSituation)
    });
    const data = await (0, $951feb090383f654$export$2e2bcd8739ae039)(query);
    return data;
}
async function $b4bf367239495756$var$sendRunExpectancyRequest(gameSituation, type) {
    const query = new URLSearchParams({
        type: type,
        params: JSON.stringify(gameSituation)
    });
    if (type === 'count') return (0, $951feb090383f654$export$2e2bcd8739ae039)(query);
    return (0, $951feb090383f654$export$2e2bcd8739ae039)(query);
}
document.addEventListener('change', async (e)=>{
    const target = e.target;
    if (!target) return;
    if (target.id === 'ddlType') {
        $b4bf367239495756$var$clearSummary();
        $b4bf367239495756$var$updateFormControls();
        $b4bf367239495756$var$emitSituation(false);
    } else {
        await $b4bf367239495756$var$emitSituation(false);
        $b4bf367239495756$var$sendSituationQuery();
    }
});
async function $b4bf367239495756$var$sendSituationQuery() {
    const showSummarySituation = (0, $d4d76553d4e85195$export$2e2bcd8739ae039)();
    if (showSummarySituation) $b4bf367239495756$var$emitSituation(true);
}
function $b4bf367239495756$var$clearSummary() {
    const summary = document.getElementById('summary');
    const summarySituation = document.getElementById('summary-situation');
    if (summary && summarySituation) {
        summary.innerHTML = '';
        summarySituation.innerHTML = '';
    }
}
function $b4bf367239495756$var$updateFormControls() {
    // hide all controls and show them based on selections
    $b4bf367239495756$var$toggleByClass('toggle-control', false);
    const selectedOption = $b4bf367239495756$var$ddlType?.options[$b4bf367239495756$var$ddlType.selectedIndex];
    const type = selectedOption?.value ?? null;
    if ($b4bf367239495756$var$lblType) $b4bf367239495756$var$lblType.textContent = selectedOption?.text ?? '';
    const runExpMessage = document.getElementById('run-exp-message');
    const winExpMessage = document.getElementById('win-exp-message');
    if (type === 'runexp') {
        $b4bf367239495756$var$toggleByClass('run-exp', true);
        $b4bf367239495756$var$toggleByClass('win-exp', false);
        $b4bf367239495756$var$strikes?.classList.remove('hidden');
        $b4bf367239495756$var$balls?.classList.remove('hidden');
        $b4bf367239495756$var$situationContainer?.classList.add('hidden');
        $b4bf367239495756$var$summaryContainer?.classList.add('hidden');
        if (runExpMessage) runExpMessage.style.display = 'block';
        if (winExpMessage) winExpMessage.style.display = 'none';
    }
    if (type === 'winexp') {
        $b4bf367239495756$var$toggleByClass('win-exp', true);
        $b4bf367239495756$var$toggleByClass('run-exp', false);
        if (winExpMessage) winExpMessage.style.display = 'block';
        if (runExpMessage) runExpMessage.style.display = 'none';
        if ($b4bf367239495756$var$winProbButton?.classList.contains('btn-active')) {
            $b4bf367239495756$var$strikes?.classList.add('hidden');
            $b4bf367239495756$var$balls?.classList.add('hidden');
            $b4bf367239495756$var$situationContainer?.classList.remove('hidden');
            $b4bf367239495756$var$summaryContainer?.classList.remove('hidden');
        } else {
            $b4bf367239495756$var$strikes?.classList.remove('hidden');
            $b4bf367239495756$var$balls?.classList.remove('hidden');
            $b4bf367239495756$var$situationContainer?.classList.add('hidden');
            $b4bf367239495756$var$summaryContainer?.classList.add('hidden');
        }
    }
}
function $b4bf367239495756$var$toggleByClass(className, show) {
    document.querySelectorAll(`.${className}`).forEach((el)=>{
        if (el) {
            const element = el;
            element.style.display = show ? '' : 'none';
        }
    });
}
document.querySelectorAll('.base').forEach((base)=>{
    const baseEl = base;
    // initialize state if missing
    if (!base.dataset.selected) {
        baseEl.dataset.selected = 'false';
        base.setAttribute('aria-pressed', 'false');
    }
    base.addEventListener('click', ()=>{
        const isSelected = base.dataset.selected === 'true';
        if (isSelected) {
            // turn OFF
            baseEl.dataset.selected = 'false';
            baseEl.setAttribute('aria-pressed', 'false');
            baseEl.classList.remove('base-selected');
            baseEl.classList.add('base-hatched');
        } else {
            // turn ON
            baseEl.dataset.selected = 'true';
            baseEl.setAttribute('aria-pressed', 'true');
            baseEl.classList.add('base-selected');
            baseEl.classList.remove('base-hatched');
        }
        $b4bf367239495756$var$emitSituation(false);
    });
});
const $b4bf367239495756$var$clearButton = document.getElementById('btnClear');
if ($b4bf367239495756$var$clearButton) $b4bf367239495756$var$clearButton.addEventListener('click', (event)=>{
    // Prevent default form submission behavior if btnSubmit is a submit type
    event.preventDefault();
    (0, $fd390bf93c17e258$export$f3fffda27536fb8b)();
    $b4bf367239495756$var$emitSituation(false);
});
const $b4bf367239495756$var$countTableWrapper = document.getElementById('game-strategy-explorer-by-count-table-wrapper');
const $b4bf367239495756$var$mainTableWrapper = document.getElementById('game-strategy-explorer-table-wrapper');
if ($b4bf367239495756$var$winProbButton) $b4bf367239495756$var$winProbButton.addEventListener('click', (event)=>{
    // Prevent default form submission behavior if btnSubmit is a submit type
    event.preventDefault();
    $b4bf367239495756$var$toggleWinProbForm();
});
if ($b4bf367239495756$var$winProbCountButton) $b4bf367239495756$var$winProbCountButton.addEventListener('click', (event)=>{
    // Prevent default form submission behavior if btnSubmit is a submit type
    event.preventDefault();
    $b4bf367239495756$var$toggleWinProbCountForm();
});
function $b4bf367239495756$var$toggleWinProbForm() {
    $b4bf367239495756$var$countTableWrapper?.classList.add('hidden');
    $b4bf367239495756$var$mainTableWrapper?.classList.remove('hidden');
    $b4bf367239495756$var$balls?.classList.add('hidden');
    $b4bf367239495756$var$strikes?.classList.add('hidden');
    $b4bf367239495756$var$summaryContainer?.classList.remove('hidden');
    $b4bf367239495756$var$situationContainer?.classList.remove('hidden');
    $b4bf367239495756$var$winProbButton?.classList.add('btn-active');
    $b4bf367239495756$var$winProbCountButton?.classList.remove('btn-active');
}
function $b4bf367239495756$var$toggleWinProbCountForm() {
    $b4bf367239495756$var$countTableWrapper?.classList.remove('hidden');
    $b4bf367239495756$var$mainTableWrapper?.classList.add('hidden');
    $b4bf367239495756$var$balls?.classList.remove('hidden');
    $b4bf367239495756$var$strikes?.classList.remove('hidden');
    $b4bf367239495756$var$summaryContainer?.classList.add('hidden');
    $b4bf367239495756$var$situationContainer?.classList.add('hidden');
    $b4bf367239495756$var$winProbButton?.classList.remove('btn-active');
    $b4bf367239495756$var$winProbCountButton?.classList.add('btn-active');
}



})();
//# sourceMappingURL=game-strategy-explorer.js.map
